import React, { useState, useRef } from 'react';
import {
    List, Datagrid, TextField, Create, SimpleForm, TextInput, RadioButtonGroupInput, Edit, EditButton, FormDataConsumer, SaveButton, Toolbar,
    AutocompleteArrayInput, useInput, SimpleList, SelectInput, FunctionField, useRedirect, useRefresh
} from 'react-admin';
// eslint-disable-next-line no-unused-vars
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, useMediaQuery, makeStyles, ListItem, ListItemIcon, ListItemText, Dialog, IconButton, Checkbox, FormControlLabel, Typography, FormControl, InputLabel, Select, MenuItem, DialogContent, DialogActions, Switch, withStyles } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { customTheme } from "./customTheme";
import RaAutocompleteInput from './components/RaAutocompleteInput';
import CustomSearch from './components/CustomSearch';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment-timezone';
import EmojiTransportationOutlinedIcon from '@material-ui/icons/EmojiTransportationOutlined';
import CustomExportButton from './components/CustomExportButton';
import config from "./config.json";
import queryString from 'query-string';
import ScrollableTable from './components/ScrollableTable';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import compose from 'recompose/compose';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import CustomCreateButton from './components/CustomCreateButton';
// eslint-disable-next-line no-unused-vars
import { changeUser } from './sharedData';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
});

const renderRole = (record) => {
    if (record.role === 'contractor') {
        return { style: { color: "#e99100", backgroundColor: "#e9910019" } }
    }
    else if (record.role === 'admin') {
        return { style: { color: "#18cc69", backgroundColor: "#18cc6919" } }
    }
    else if (record.role === 'sales') {
        return { style: { color: "#109cf1", backgroundColor: "#109cf119" } }
    }
    else {
        return { style: { color: "#de575e", backgroundColor: "#de575e19" } }
    }
}

let CATEGORY = "DASHBOARD USERS SECTION"

const getSearchState = (searchObj) => {
    let newSearch = []
    for (let i in searchObj) {
        if (searchObj[i].showSearch) {
            newSearch.push(searchObj[i].name)
        }
    }
    return newSearch
}

export const CrmUserList = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const refresh = useRefresh();
    const listDataRef = useRef();

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchStateObject = [
        { name: "Username", showSearch: true },
        { name: "Mobile", showSearch: true },
    ]
    let searchTypeState = getSearchState(searchStateObject)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Username");
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };

    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };


    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getExportFile = (fileType) => {
        const { current: { total, currentSort, filterValues } } = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/crmUsers?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "Dashboard Users"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    React.useEffect(() => {
        eventTracker(CATEGORY, " DASHBOARD USERS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (<div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomCreateButton label="Create User" basePath="/crmUsers" resource="crmUsers" />
            <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>
        <List
            {...props}
            style={{ marginTop: 20 }}
            title="CRM Users"
            bulkActionButtons={false}
            filter={filter}
            actions={false}
            empty={false}
            pagination={<CustomPagination setListData={(listData) => { listDataRef.current = listData }} />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => <div style={{ paddingRight: 24 }}>{record.username ? `Username: ${record.username}` : ""}</div>}
                    secondaryText={record => (<div>
                        {record.full_name && <div style={{ paddingRight: 24 }} ><span style={{ color: "#5a5a5a" }}>Name: </span>{record.full_name}</div>}
                        {record.mobile && <div style={{ paddingRight: 24 }} ><span style={{ color: "#5a5a5a" }}>Mobile: </span>{record.mobile}</div>}
                        <FunctionField
                            source="role"
                            label="Role"
                            render={record => {
                                let recordResult = renderRole(record)
                                return <div style={{ margin: "6px 0px" }}>
                                    <div style={{ color: "#5a5a5a" }}>Role: <span style={{ ...recordResult.style, padding: "1px 8px", borderRadius: 500 }}>{record.role}</span></div>
                                </div>
                            }}
                        />
                        {record.last_login_time && <div style={{ paddingRight: 24 }} ><span style={{ color: "#5a5a5a" }}>Last Login: </span>{renderTime(record["last_login_time"])}</div>}
                        {record.last_login_location && <div style={{ paddingRight: 24 }} ><span style={{ color: "#5a5a5a" }}>Last Login Location: </span>{record.last_login_location}</div>}
                        {record.last_logged_device && <div style={{ paddingRight: 24 }} ><span style={{ color: "#5a5a5a" }}>Last Login Device: </span>{record.last_logged_device}</div>}
                        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                            <span style={{ color: "#5a5a5a" }}>Client Parkings:</span>
                            <UserParkings {...props} record={record} source="user_parkings" label="User Parkings" />
                        </div>
                        {!viewOnly && <div style={{ display: "flex", gap: 10, justifyContent: "space-between", alignItems: "center" }}>
                            {/* <VisibilityIcon/> */}
                            <EditButton {...props} record={record} label="Edit" />
                            <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/crmUsers'} />
                        </div>}
                    </div>)}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid component={ScrollableTable} className={!viewOnly ? 'dashboardUsersDataGrid' : ''}>
                    <CrmUserToggler label={false} source="enable" />
                    <TextField source="username" />
                    <FunctionField source='full_name' label="Name" render={record => record && <span>{record.full_name ? record.full_name : '-'}</span>} />
                    <FunctionField source='mobile' label="Mobile" render={record => record && <span>{record.mobile ? record.mobile : '-'}</span>} />
                    {/* <ChipField source="role" /> */}
                    <FunctionField
                        source="role"
                        label="Role"
                        render={record => {
                            let recordResult = renderRole(record)
                            return record ? <div>
                                <div
                                    className={classes.chipCell}
                                    style={{ ...recordResult.style, marginBottom: "5px" }}
                                >
                                    {record.role}
                                </div>
                            </div> : "-"
                        }}
                    />
                    <UserParkings source="user_parkings" label="User Parkings" />
                    <FunctionField source="last_login_time" label="Last Login" render={record => record && record.last_login_time ? renderTime(record["last_login_time"]) : ""} />
                    <TextField source='last_login_location' label='Last Login Location' />
                    <TextField source='last_logged_device' label='Last Login Device' />
                    {/* <EditButton /> */}
                    {!viewOnly && <FunctionField className="ListIconsContainerDashboardUsers" render={record => record &&
                        <div className="ListIcons">
                            {/* <div style={{marginTop:"5px", marginRight:"5px"}}>
                                <button style={{all:"unset" , cursor:"pointer"}} onClick={() => changeUser(record)}><VisibilityIcon /></button>
                            </div> */}
                            <div>
                                <EditButton {...props} title="Edit" label={false} record={record} />
                            </div>
                            <div>
                                <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/crmUsers'} />
                            </div>

                        </div>
                    } />}
                </Datagrid>
            }
        </List>
    </div>);
}

function UserEnableToggler(props) {
    const classes = useStyles()
    const { record } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, basePath } = props;
        const data = {
            ...record,
            enable: !record.enable === false ? 0 : 1,
        };
        dispatchCrudUpdate('crmUsers', record.id, data, record, basePath, "/crmUsers");
    };

    if (!record) return null
    return (
        <div style={{ textAlign: "left", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {isSmallDevice && <div>User Enable:</div>}
            <AntSwitch checked={Boolean(record.enable)} onChange={openDialog} />

            <Dialog open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }}>
                <DialogContent>
                    <p>Are you sure you want to <strong>{record.enable ? "Disable" : "Enable"}</strong> this User?</p>
                </DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
UserEnableToggler.defaultProps = {
    redirect: 'list',
    undoable: false
};
const CrmUserToggler = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(UserEnableToggler);

function UserParkings(props) {
    const { record, source } = props;

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    if (!record[source])
        return null;

    const parkings = JSON.parse(record[source])

    return (
        <div style={{ textAlign: "left", display: "block", alignItems: "center", flex: 1 }}>
            <IconButton style={{ width: 40, height: 40, fontSize: 16, color: customTheme.palette.secondary.main }} onClick={openDialog}>{parkings.length}</IconButton>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog} PaperProps={{ style: { maxWidth: 400 } }}>
                {parkings.map(parking => (
                    <ListItem>
                        <ListItemIcon><EmojiTransportationOutlinedIcon /></ListItemIcon>
                        <ListItemText primary={parking} />
                    </ListItem>
                ))}
            </Dialog>
        </div>
    );
}

const validateUserCreation = (values) => {
    // const emailRegex = /\S+@\S+\.\S+/;
    // const mobileRegex = /^\d{10}$/g;
    const usernameRegex = /^[a-zA-Z0-9_]*$/;
    const errors = {};
    if (!values.username) {
        errors.username = 'Username is required';
    }
    if (values.username && !usernameRegex.test(values.username)) {
        errors.username = 'Only alphabets, underscores, and numbers are allowed.';
    }
    if (!values.password) {
        errors.password = 'Password is required';
    }
    if (!values.confirm_password) {
        errors.confirm_password = 'Confirm Password is required';
    }
    if (values.password !== values.confirm_password) {
        errors.confirm_password = 'Confirm Password does not match';
    }
    if (!values.role) {
        errors.role = 'Role is required';
    }
    if (values.role !== "admin" && !values.access_key) {
        errors.access_key = 'Access Key is required';
    }
    return errors
};

const validateUserEdit = (values) => {
    // const emailRegex = /\S+@\S+\.\S+/;
    // const mobileRegex = /^\d{10}$/g;
    const errors = {};
    if (!values.username) {
        errors.username = 'Username is required';
    }
    if (values.edit_password) {
        if (!values.new_password) {
            errors.password = 'Password is required';
        }
        if (!values.confirm_password) {
            errors.confirm_password = 'Confirm Password is required';
        }
        if (values.new_password !== values.confirm_password) {
            errors.confirm_password = 'Confirm Password does not match';
        }
    }
    if (!values.role) {
        errors.role = 'Role is required';
    }
    return errors
};

const CustomToolbar = (props) => {
    return <Toolbar {...props} >
        <SaveButton disableElevation style={{ marginTop: 15 }} />
    </Toolbar>
}

const CustomEditPasswordField = props => {
    const { input: { value: editPassword, onChange: setEditPassword } } = useInput({ ...props, id: "edit_password", source: "edit_password" });

    return (editPassword ?
        <>
            <div><TextInput {...props} source="new_password" type="password" variant="outlined" /></div>
            <div><TextInput {...props} source="confirm_password" type="password" label="Confirm Password" variant="outlined" /></div>
        </>
        :
        <Button startIcon={<EditIcon />} onClick={() => setEditPassword(true)} style={{ width: 180, marginBottom: 15 }}>Edit Password</Button>
    )
}


const CustomEditForm = (props) => {
    const { input: { value: allow_unallocated_rfid, onChange: set_allow_unallocated_rfid } } = useInput({ ...props, id: "allow_unallocated_rfid", source: "allow_unallocated_rfid" });
    const { input: { value: all_parkings_details, onChange: set_all_parkings_details } } = useInput({ ...props, id: "all_parkings_details", source: "all_parkings_details" });
    const { input: { value: allow_company_user_create, onChange: set_allow_company_user_create } } = useInput({ ...props, id: "allow_company_user_create", source: "allow_company_user_create" });
    const { input: { value: allow_current_vehicles_update, onChange: set_allow_current_vehicles_update } } = useInput({ ...props, id: "allow_current_vehicles_update", source: "allow_current_vehicles_update" });
    const { input: { value: allow_edit_monthly_pass, onChange: set_allow_edit_monthly_pass } } = useInput({ ...props, id: "allow_edit_monthly_pass", source: "allow_edit_monthly_pass" });
    const { input: { value: allow_fastag, onChange: set_allow_fastag } } = useInput({ ...props, id: "allow_fastag", source: "allow_fastag" });
    const { input: { value: allow_pass_delete, onChange: set_allow_pass_delete } } = useInput({ ...props, id: "allow_pass_delete", source: "allow_pass_delete" });
    const { input: { value: allow_pass_recharge, onChange: set_allow_pass_recharge } } = useInput({ ...props, id: "allow_pass_recharge", source: "allow_pass_recharge" });
    const { input: { value: allow_rfid_create, onChange: set_allow_rfid_create } } = useInput({ ...props, id: "allow_rfid_create", source: "allow_rfid_create" });
    const { input: { value: allow_rfid_delete, onChange: set_allow_rfid_delete } } = useInput({ ...props, id: "allow_rfid_delete", source: "allow_rfid_delete" });
    const { input: { value: company_user, onChange: set_company_user } } = useInput({ ...props, id: "company_user", source: "company_user" });
    const { input: { value: create_permit_name_required, onChange: set_create_permit_name_required } } = useInput({ ...props, id: "create_permit_name_required", source: "create_permit_name_required" });
    const { input: { value: hide_device_issues, onChange: set_hide_device_issues } } = useInput({ ...props, id: "hide_device_issues", source: "hide_device_issues" });

    const { input: { value: hide_operator_users, onChange: set_hide_operator_users } } = useInput({ ...props, id: "hide_operator_users", source: "hide_operator_users" });
    const { input: { value: hide_parking_details, onChange: set_hide_parking_details } } = useInput({ ...props, id: "hide_parking_details", source: "hide_parking_details" });
    const { input: { value: hide_parking_led, onChange: set_hide_parking_led } } = useInput({ ...props, id: "hide_parking_led", source: "hide_parking_led" });
    const { input: { value: hide_parking_section, onChange: set_hide_parking_section } } = useInput({ ...props, id: "hide_parking_section", source: "hide_parking_section" });
    const { input: { value: hide_vehicle_database, onChange: set_hide_vehicle_database } } = useInput({ ...props, id: "hide_vehicle_database", source: "hide_vehicle_database" });
    const { input: { value: show_avg_summary_amount, onChange: set_show_avg_summary_amount } } = useInput({ ...props, id: "show_avg_summary_amount", source: "show_avg_summary_amount" });
    const { input: { value: show_device_wallet, onChange: set_show_device_wallet } } = useInput({ ...props, id: "show_device_wallet", source: "show_device_wallet" });
    const { input: { value: show_exempted_vehicles, onChange: set_show_exempted_vehicles } } = useInput({ ...props, id: "show_exempted_vehicles", source: "show_exempted_vehicles" });
    const { input: { value: show_fastag_payment, onChange: set_show_fastag_payment } } = useInput({ ...props, id: "show_fastag_payment", source: "show_fastag_payment" });
    const { input: { value: show_flat_details, onChange: set_show_flat_details } } = useInput({ ...props, id: "show_flat_details", source: "show_flat_details" });
    const { input: { value: show_inventory, onChange: set_show_inventory } } = useInput({ ...props, id: "show_inventory", source: "show_inventory" });
    const { input: { value: show_monthly_pass, onChange: set_show_monthly_pass } } = useInput({ ...props, id: "show_monthly_pass", source: "show_monthly_pass" });
    const { input: { value: show_monthly_pass_log, onChange: set_show_monthly_pass_log } } = useInput({ ...props, id: "show_monthly_pass_log", source: "show_monthly_pass_log" });
    const { input: { value: show_monthlypass_request, onChange: set_show_monthlypass_request } } = useInput({ ...props, id: "show_monthlypass_request", source: "show_monthlypass_request" });
    const { input: { value: show_operator, onChange: set_show_operator } } = useInput({ ...props, id: "show_operator", source: "show_operator" });
    const { input: { value: show_paid_unpaid_amount, onChange: set_show_paid_unpaid_amount } } = useInput({ ...props, id: "show_paid_unpaid_amount", source: "show_paid_unpaid_amount" });
    const { input: { value: show_parking_controllers, onChange: set_show_parking_controllers } } = useInput({ ...props, id: "show_parking_controllers", source: "show_parking_controllers" });
    const { input: { value: show_parking_slot_bookings, onChange: set_show_parking_slot_bookings } } = useInput({ ...props, id: "show_parking_slot_bookings", source: "show_parking_slot_bookings" });
    const { input: { value: show_permit_apartments, onChange: set_show_permit_apartments } } = useInput({ ...props, id: "show_permit_apartments", source: "show_permit_apartments" });
    const { input: { value: show_rfid, onChange: set_show_rfid } } = useInput({ ...props, id: "show_rfid", source: "show_rfid" });
    const { input: { value: show_rfid_column, onChange: set_show_rfid_column } } = useInput({ ...props, id: "show_rfid_column", source: "show_rfid_column" });
    const { input: { value: show_rfid_company, onChange: set_show_rfid_company } } = useInput({ ...props, id: "show_rfid_company", source: "show_rfid_company" });
    const { input: { value: show_rfid_inventory, onChange: set_show_rfid_inventory } } = useInput({ ...props, id: "show_rfid_inventory", source: "show_rfid_inventory" });
    const { input: { value: show_rfid_recharge, onChange: set_show_rfid_recharge } } = useInput({ ...props, id: "show_rfid_recharge", source: "show_rfid_recharge" });
    const { input: { value: show_rfid_requests, onChange: set_show_rfid_requests } } = useInput({ ...props, id: "show_rfid_requests", source: "show_rfid_requests" });
    const { input: { value: show_tag_column, onChange: set_show_tag_column } } = useInput({ ...props, id: "show_tag_column", source: "show_tag_column" });
    const { input: { value: show_time_till_seconds, onChange: set_show_time_till_seconds } } = useInput({ ...props, id: "show_time_till_seconds", source: "show_time_till_seconds" });
    const { input: { value: show_vaccine_drive, onChange: set_show_vaccine_drive } } = useInput({ ...props, id: "show_vaccine_drive", source: "show_vaccine_drive" });
    const { input: { value: show_validity_column, onChange: set_show_validity_column } } = useInput({ ...props, id: "show_validity_column", source: "show_validity_column" });
    const { input: { value: show_verify_vehicle, onChange: set_show_verify_vehicle } } = useInput({ ...props, id: "show_verify_vehicle", source: "show_verify_vehicle" });
    const { input: { value: view_only, onChange: set_view_only } } = useInput({ ...props, id: "view_only", source: "view_only" });
    const { input: { value: rfid_validity_default, onChange: set_rfid_validity_default } } = useInput({ ...props, id: "rfid_validity_default", source: "rfid_validity_default" });

    const { input: { value: show_resources_separately, onChange: set_show_resources_separately } } = useInput({ ...props, id: "show_resources_separately", source: "show_resources_separately" });
    const { input: { value: show_profile, onChange: set_show_profile } } = useInput({ ...props, id: "show_profile", source: "show_profile" });
    const { input: { value: show_visitor_logs, onChange: set_show_visitor_logs } } = useInput({ ...props, id: "show_visitor_logs", source: "show_visitor_logs" });

    const { input: { value: hide_mobile_number, onChange: set_hide_mobile_number } } = useInput({ ...props, id: "hide_mobile_number", source: "hide_mobile_number" });
    const { input: { value: show_reserved_column, onChange: set_show_reserved_column } } = useInput({ ...props, id: "show_reserved_column", source: "show_reserved_column" });
    const { input: { value: show_exit_vehicle_button, onChange: set_show_exit_vehicle_button } } = useInput({ ...props, id: "show_exit_vehicle_button", source: "show_exit_vehicle_button" });
    const { input: { value: show_ieems_section, onChange: set_show_ieems_section } } = useInput({ ...props, id: "show_ieems_section", source: "show_ieems_section" });
    const { input: { value: show_rfid_logs, onChange: set_show_rfid_logs } } = useInput({ ...props, id: "show_rfid_logs", source: "show_rfid_logs" });
    const { input: { value: show_company_column, onChange: set_show_company_column } } = useInput({ ...props, id: "show_company_column", source: "show_company_column" });
    const { input: { value: show_permits, onChange: set_show_permits } } = useInput({ ...props, id: "show_permits", source: "show_permits" });
    const { input: { value: show_clients_info, onChange: set_show_clients_info } } = useInput({ ...props, id: "show_clients_info", source: "show_clients_info" });
    const { input: { value: show_dashboard_users, onChange: set_show_dashboard_users } } = useInput({ ...props, id: "show_dashboard_users", source: "show_dashboard_users" });
    const { input: { value: show_card_inventory, onChange: set_show_card_inventory } } = useInput({ ...props, id: "show_card_inventory", source: "show_card_inventory" });
    const { input: { value: show_rfid_deleted_details, onChange: set_show_rfid_deleted_details } } = useInput({ ...props, id: "show_rfid_deleted_details", source: "show_rfid_deleted_details" });
    const { input: { value: show_site_audits, onChange: set_show_site_audits } } = useInput({ ...props, id: "show_site_audits", source: "show_site_audits" });
    const { input: { value: show_warrior_users, onChange: set_show_warrior_users } } = useInput({ ...props, id: "show_warrior_users", source: "show_warrior_users" });
    const { input: { value: show_device_issues, onChange: set_show_device_issues } } = useInput({ ...props, id: "show_device_issues", source: "show_device_issues" });
    const { input: { value: show_map_view, onChange: set_show_map_view } } = useInput({ ...props, id: "show_map_view", source: "show_map_view" });
    const { input: { value: show_parking_details, onChange: set_show_parking_details } } = useInput({ ...props, id: "show_parking_details", source: "show_parking_details" });
    const { input: { value: show_dashboard_logs, onChange: set_show_dashboard_logs } } = useInput({ ...props, id: "show_dashboard_logs", source: "show_dashboard_logs" });
    const { input: { value: show_fastag_api_data, onChange: set_show_fastag_api_data } } = useInput({ ...props, id: "show_fastag_api_data", source: "show_fastag_api_data" });
    const { input: { value: show_onboard_users, onChange: set_show_onboard_users } } = useInput({ ...props, id: "show_onboard_users", source: "show_onboard_users" });
    const { input: { value: show_parking_terminals, onChange: set_show_parking_terminals } } = useInput({ ...props, id: "show_parking_terminals", source: "show_parking_terminals" });
    const { input: { value: allow_create_parking, onChange: set_allow_create_parking } } = useInput({ ...props, id: "allow_create_parking", source: "allow_create_parking" });
    const { input: { value: allow_download_parkings, onChange: set_allow_download_parkings } } = useInput({ ...props, id: "allow_download_parkings", source: "allow_download_parkings" });
    const { input: { value: allow_update_parking, onChange: set_allow_update_parking } } = useInput({ ...props, id: "allow_update_parking", source: "allow_update_parking" });
    const { input: { value: allow_parking_led_settings, onChange: set_allow_parking_led_settings } } = useInput({ ...props, id: "allow_parking_led_settings", source: "allow_parking_led_settings" });
    const { input: { value: allow_parking_info_edit, onChange: set_allow_parking_info_edit } } = useInput({ ...props, id: "allow_parking_info_edit", source: "allow_parking_info_edit" });
    const { input: { value: allow_parking_license_update, onChange: set_allow_parking_license_update } } = useInput({ ...props, id: "allow_parking_license_update", source: "allow_parking_license_update" });
    const { input: { value: allow_parking_status_toggle, onChange: set_allow_parking_status_toggle } } = useInput({ ...props, id: "allow_parking_status_toggle", source: "allow_parking_status_toggle" });
    const { input: { value: allow_terminal_edit, onChange: set_allow_terminal_edit } } = useInput({ ...props, id: "allow_terminal_edit", source: "allow_terminal_edit" });
    const { input: { value: show_parking_analytics, onChange: set_show_parking_analytics } } = useInput({ ...props, id: "show_parking_analytics", source: "show_parking_analytics" });
    const { input: { value: show_dashboard_summary, onChange: set_show_dashboard_summary } } = useInput({ ...props, id: "show_dashboard_summary", source: "show_dashboard_summary" });
    const { input: { value: create_without_terminal, onChange: set_create_without_terminal } } = useInput({ ...props, id: "create_without_terminal", source: "create_without_terminal" });
    const { input: { value: allow_terminal_device_changes, onChange: set_allow_terminal_device_changes } } = useInput({ ...props, id: "allow_terminal_device_changes", source: "allow_terminal_device_changes" });
    const { input: { value: show_purchased_fastag, onChange: set_show_purchased_fastag } } = useInput({ ...props, id: "show_purchased_fastag", source: "show_purchased_fastag" });
    const { input: { value: create_permit_without_mobile, onChange: set_create_permit_without_mobile } } = useInput({ ...props, id: "create_permit_without_mobile", source: "create_permit_without_mobile" });
    const { input: { value: show_cameras, onChange: set_show_cameras } } = useInput({ ...props, id: "show_cameras", source: "show_cameras" });
    const { input: { value: separate_summary_of_devices, onChange: set_separate_summary_of_devices } } = useInput({ ...props, id: "separate_summary_of_devices", source: "separate_summary_of_devices" });
    const { input: { value: use_24_hour_format, onChange: set_use_24_hour_format } } = useInput({ ...props, id: "use_24_hour_format", source: "use_24_hour_format" });
    const { input: { value: show_surveillance_images, onChange: set_show_surveillance_images } } = useInput({ ...props, id: "show_surveillance_images", source: "show_surveillance_images" });
    const { input: { value: use_latest_version, onChange: set_use_latest_version } } = useInput({ ...props, id: "use_latest_version", source: "use_latest_version" });

    const { input: { value: show_anpr_raw_image, onChange: set_show_anpr_raw_image } } = useInput({ ...props, id: "show_anpr_raw_image", source: "show_anpr_raw_image" });
    const { input: { value: make_exit_free, onChange: set_make_exit_free } } = useInput({ ...props, id: "make_exit_free", source: "make_exit_free" });
    const { input: { value: show_reports, onChange: set_show_reports } } = useInput({ ...props, id: "show_reports", source: "show_reports" });
    const { input: { value: show_patrolling, onChange: set_show_patrolling } } = useInput({ ...props, id: "show_patrolling", source: "show_patrolling" });
    const { input: { value: separate_entry_exit_images, onChange: set_separate_entry_exit_images } } = useInput({ ...props, id: "separate_entry_exit_images", source: "separate_entry_exit_images" });
    const { input: { value: vehicle_mobile_mask, onChange: set_vehicle_mobile_mask } } = useInput({ ...props, id: "vehicle_mobile_mask", source: "vehicle_mobile_mask" });
    const { input: { value: check_vehicle_exit, onChange: set_check_vehicle_exit } } = useInput({ ...props, id: "check_vehicle_exit", source: "check_vehicle_exit" });
    const { input: { value: demo_access, onChange: set_demo_access } } = useInput({ ...props, id: "demo_access", source: "demo_access" });

    const { input: { value: create_sub_user, onChange: set_create_sub_user } } = useInput({ ...props, id: "create_sub_user", source: "create_sub_user" });
    const { input: { value: show_qr_transactions, onChange: set_show_qr_transactions } } = useInput({ ...props, id: "show_qr_transactions", source: "show_qr_transactions" });
    const { input: { value: show_rfid_payments, onChange: set_show_rfid_payments } } = useInput({ ...props, id: "show_rfid_payments", source: "show_rfid_payments" });
    const { input: { value: show_anpr_options, onChange: set_show_anpr_options } } = useInput({ ...props, id: "show_anpr_options", source: "show_anpr_options" });
    const { input: { value: show_ramp_entry, onChange: set_show_ramp_entry } } = useInput({ ...props, id: "show_ramp_entry", source: "show_ramp_entry" });
    const { input: { value: show_floor_occupancy, onChange: set_show_floor_occupancy } } = useInput({ ...props, id: "show_floor_occupancy", source: "show_floor_occupancy" });
    const { input: { value: vehicle_summary_mask, onChange: set_vehicle_summary_mask } } = useInput({ ...props, id: "vehicle_summary_mask", source: "vehicle_summary_mask" });

    const { input: { value: show_dashboard_categories, onChange: set_show_dashboard_categories } } = useInput({ ...props, id: "show_dashboard_categories", source: "show_dashboard_categories" });
    const { input: { value: show_currently_parked, onChange: set_show_currently_parked } } = useInput({ ...props, id: "show_currently_parked", source: "show_currently_parked" });
    const { input: { value: show_settlements, onChange: set_show_settlements } } = useInput({ ...props, id: "show_settlements", source: "show_settlements" });
    const { input: { value: edit_device_limit, onChange: set_edit_device_limit } } = useInput({ ...props, id: "edit_device_limit", source: "edit_device_limit" });
    const { input: { value: slot_name_required, onChange: set_slot_name_required } } = useInput({ ...props, id: "slot_name_required", source: "slot_name_required" });
    const { input: { value: restrict_permits, onChange: set_restrict_permits } } = useInput({ ...props, id: "restrict_permits", source: "restrict_permits" });
    const { input: { value: disable_downloads, onChange: set_disable_downloads } } = useInput({ ...props, id: "disable_downloads", source: "disable_downloads" });
    const { input: { value: allow_visitor_delete, onChange: set_allow_visitor_delete } } = useInput({ ...props, id: "allow_visitor_delete", source: "allow_visitor_delete" });
    const { input: { value: allow_client_view, onChange: set_allow_client_view } } = useInput({ ...props, id: "allow_client_view", source: "allow_client_view" });
    const { input: { value: hide_summary_search, onChange: set_hide_summary_search } } = useInput({ ...props, id: "hide_summary_search", source: "hide_summary_search" });
    const { input: { value: show_barrier_activity, onChange: set_show_barrier_activity } } = useInput({ ...props, id: "show_barrier_activity", source: "show_barrier_activity" });
    const { input: { value: show_pucc_validity, onChange: set_show_pucc_validity } } = useInput({ ...props, id: "show_pucc_validity", source: "show_pucc_validity" });
    const { input: { value: show_dashboard_insights, onChange: set_show_dashboard_insights } } = useInput({ ...props, id: "show_dashboard_insights", source: "show_dashboard_insights" });
    const { input: { value: hide_date_wise_filter, onChange: set_hide_date_wise_filter } } = useInput({ ...props, id: "hide_date_wise_filter", source: "hide_date_wise_filter" });
    const { input: { value: hide_monthly_wise_date_filter, onChange: set_hide_monthly_wise_date_filter } } = useInput({ ...props, id: "hide_monthly_wise_date_filter", source: "hide_monthly_wise_date_filter" });
    const { input: { value: hide_custom_date_filter, onChange: set_hide_custom_date_filter } } = useInput({ ...props, id: "hide_custom_date_filter", source: "hide_custom_date_filter" });
    const { input: { value: hide_time_filter, onChange: set_hide_time_filter } } = useInput({ ...props, id: "hide_time_filter", source: "hide_time_filter" });
    const { input: { value: date_till_yesterday, onChange: set_date_till_yesterday } } = useInput({ ...props, id: "date_till_yesterday", source: "date_till_yesterday" });
    const { input: { value: show_qr_codes, onChange: set_show_qr_codes } } = useInput({ ...props, id: "show_qr_codes", source: "show_qr_codes" });
    const { input: { value: show_valet_bookings, onChange: set_show_valet_bookings } } = useInput({ ...props, id: "show_valet_bookings", source: "show_valet_bookings" });
    const { input: { value: show_missed_visitors, onChange: set_show_missed_visitors } } = useInput({ ...props, id: "show_missed_visitors", source: "show_missed_visitors" });
    const { input: { value: show_apartment_as_unit, onChange: set_show_apartment_as_unit } } = useInput({ ...props, id: "show_apartment_as_unit", source: "show_apartment_as_unit" });
    const { input: { value: only_allow_day_permit, onChange: set_only_allow_day_permit } } = useInput({ ...props, id: "only_allow_day_permit", source: "only_allow_day_permit" });
    const { input: { value: hide_resources, onChange: set_hide_resources } } = useInput({ ...props, id: "hide_resources", source: "hide_resources" });
    const { input: { value: hide_contact_us, onChange: set_hide_contact_us } } = useInput({ ...props, id: "hide_contact_us", source: "hide_contact_us" });
    const { input: { value: show_linked_permit_logs, onChange: set_show_linked_permit_logs } } = useInput({ ...props, id: "show_linked_permit_logs", source: "show_linked_permit_logs" });
    const { input: { value: show_permit_validity_toggle, onChange: set_show_permit_validity_toggle } } = useInput({ ...props, id: "show_permit_validity_toggle", source: "show_permit_validity_toggle" });
    const { input: { value: hide_permit_amount_details, onChange: set_hide_permit_amount_details } } = useInput({ ...props, id: "hide_permit_amount_details", source: "hide_permit_amount_details" });
    const { input: { value: show_billing_invocies, onChange: set_show_billing_invocies } } = useInput({ ...props, id: "show_billing_invocies", source: "show_billing_invocies" });
    const { input: { value: show_invoices_user_permits, onChange: set_show_invoices_user_permits } } = useInput({ ...props, id: "show_invoices_user_permits", source: "show_invoices_user_permits" });
    const { input: { value: show_invoices_vaahan_api, onChange: set_show_invoices_vaahan_api } } = useInput({ ...props, id: "show_invoices_vaahan_api", source: "show_invoices_vaahan_api" });
    const { input: { value: allow_add_inventory_tags, onChange: set_allow_add_inventory_tags } } = useInput({ ...props, id: "allow_add_inventory_tags", source: "allow_add_inventory_tags" });
    const { input: { value: hide_permit_user_bulk_action, onChange: set_hide_permit_user_bulk_action } } = useInput({ ...props, id: "hide_permit_user_bulk_action", source: "hide_permit_user_bulk_action" });
    const { input: { value: hide_change_password, onChange: set_hide_change_password } } = useInput({ ...props, id: "hide_change_password", source: "hide_change_password" });
    const { input: { value: hide_permit_users_filter, onChange: set_hide_permit_users_filter } } = useInput({ ...props, id: "hide_permit_users_filter", source: "hide_permit_users_filter" });
    const { input: { value: only_show_vehicle_search, onChange: set_only_show_vehicle_search } } = useInput({ ...props, id: "only_show_vehicle_search", source: "only_show_vehicle_search" });
    const { input: { value: hide_unnecessary_permit_users_column, onChange: set_hide_unnecessary_permit_users_column } } = useInput({ ...props, id: "hide_unnecessary_permit_users_column", source: "hide_unnecessary_permit_users_column" });
    const { input: { value: show_tutorial, onChange: set_show_tutorial } } = useInput({ ...props, id: "show_tutorial", source: "show_tutorial" });
    const { input: { value: show_vehicle_not_registered_msg, onChange: set_show_vehicle_not_registered_msg } } = useInput({ ...props, id: "show_vehicle_not_registered_msg", source: "show_vehicle_not_registered_msg" });
    const { input: { value: show_searched_data_only, onChange: set_show_searched_data_only } } = useInput({ ...props, id: "show_searched_data_only", source: "show_searched_data_only" });
    const { input: { value: show_permit_defaulter, onChange: set_show_permit_defaulter } } = useInput({ ...props, id: "show_permit_defaulter", source: "show_permit_defaulter" });
    const { input: { value: show_grace_period, onChange: set_show_grace_period } } = useInput({ ...props, id: "show_grace_period", source: "show_grace_period" });
    const { input: { value: show_grace_period_logs, onChange: set_show_grace_period_logs } } = useInput({ ...props, id: "show_grace_period_logs", source: "show_grace_period_logs" });
    const { input: { value: show_grace_period_configurations, onChange: set_show_grace_period_configurations } } = useInput({ ...props, id: "show_grace_period_configurations", source: "show_grace_period_configurations" });
    const { input: { value: show_billings_maintenance_plan, onChange: set_show_billings_maintenance_plan } } = useInput({ ...props, id: "show_billings_maintenance_plan", source: "show_billings_maintenance_plan" });
    const { input: { value: show_floor_occupancy_edit, onChange: set_show_floor_occupancy_edit } } = useInput({ ...props, id: "show_floor_occupancy_edit", source: "show_floor_occupancy_edit" });
    const { input: { value: show_start_end_date_pairing_input, onChange: set_show_start_end_date_pairing_input } } = useInput({ ...props, id: "show_start_end_date_pairing_input", source: "show_start_end_date_pairing_input" });
    const { input: { value: auto_refresh_vehicle_summary, onChange: set_auto_refresh_vehicle_summary } } = useInput({ ...props, id: "auto_refresh_vehicle_summary", source: "auto_refresh_vehicle_summary" });
    const { input: { value: show_operator_devices, onChange: set_show_operator_devices } } = useInput({ ...props, id: "show_operator_devices", source: "show_operator_devices" });
    const { input: { value: show_operator_shifts, onChange: set_show_operator_shifts } } = useInput({ ...props, id: "show_operator_shifts", source: "show_operator_shifts" });
    const { input: { value: show_operator_users, onChange: set_show_operator_users } } = useInput({ ...props, id: "show_operator_users", source: "show_operator_users" });

    return <div style={{ marginBottom: 40 }}>
        <Typography style={{ marginBottom: 15, fontWeight: "bold" }}>User Configuration:</Typography>
        <>
            <div style={{ marginTop: 20 }}>
                <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>Permit:</Typography>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                    <FormControlLabel control={<Checkbox
                        checked={allow_unallocated_rfid === 1 ? true : false}
                        onChange={(event) => set_allow_unallocated_rfid(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Unallocated RFID" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_company_user_create === 1 ? true : false}
                        onChange={(event) => set_allow_company_user_create(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Company user Create" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_fastag === 1 ? true : false}
                        onChange={(event) => set_allow_fastag(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Fastag" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_rfid_create === 1 ? true : false}
                        onChange={(event) => set_allow_rfid_create(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow RFID Create" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_rfid_delete === 1 ? true : false}
                        onChange={(event) => set_allow_rfid_delete(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow RFID Delete" />
                    <FormControlLabel control={<Checkbox
                        checked={company_user === 1 ? true : false}
                        onChange={(event) => set_company_user(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Company User" />
                    <FormControlLabel control={<Checkbox
                        checked={create_permit_name_required === 1 ? true : false}
                        onChange={(event) => set_create_permit_name_required(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Create Permit Name Required" />
                    <FormControlLabel control={<Checkbox
                        checked={show_fastag_payment === 1 ? true : false}
                        onChange={(event) => set_show_fastag_payment(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Fastag Payment" />
                    <FormControlLabel control={<Checkbox
                        checked={show_flat_details === 1 ? true : false}
                        onChange={(event) => set_show_flat_details(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Flat Details" />
                    <FormControlLabel control={<Checkbox
                        checked={show_permit_apartments === 1 ? true : false}
                        onChange={(event) => set_show_permit_apartments(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Permit Apartments" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid === 1 ? true : false}
                        onChange={(event) => set_show_rfid(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_column === 1 ? true : false}
                        onChange={(event) => set_show_rfid_column(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID Column" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_recharge === 1 ? true : false}
                        onChange={(event) => set_show_rfid_recharge(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID Recharge" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_company === 1 ? true : false}
                        onChange={(event) => set_show_rfid_company(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID Company" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_requests === 1 ? true : false}
                        onChange={(event) => set_show_rfid_requests(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID Requests" />
                    <FormControlLabel control={<Checkbox
                        checked={show_tag_column === 1 ? true : false}
                        onChange={(event) => set_show_tag_column(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Tag Column" />
                    <FormControlLabel control={<Checkbox
                        checked={show_validity_column === 1 ? true : false}
                        onChange={(event) => set_show_validity_column(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="RFID Validity Column" />
                    <FormControlLabel control={<Checkbox
                        checked={rfid_validity_default === 1 ? true : false}
                        onChange={(event) => set_rfid_validity_default(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="RFID Validity Default" />

                    <FormControlLabel control={<Checkbox
                        checked={show_resources_separately === 1 ? true : false}
                        onChange={(event) => set_show_resources_separately(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Resources Separately" />

                    <FormControlLabel control={<Checkbox
                        checked={show_profile === 1 ? true : false}
                        onChange={(event) => set_show_profile(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Profile" />
                    <FormControlLabel control={<Checkbox
                        checked={hide_mobile_number === 1 ? true : false}
                        onChange={(event) => set_hide_mobile_number(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Hide Mobile Number" />
                    <FormControlLabel control={<Checkbox
                        checked={show_reserved_column === 1 ? true : false}
                        onChange={(event) => set_show_reserved_column(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Reserved Column" />
                    <FormControlLabel control={<Checkbox
                        checked={show_exit_vehicle_button === 1 ? true : false}
                        onChange={(event) => set_show_exit_vehicle_button(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Exit Vehicle Button" />
                    <FormControlLabel control={<Checkbox
                        checked={show_permits === 1 ? true : false}
                        onChange={(event) => set_show_permits(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Permits" />
                </div>
            </div>


            <div style={{ marginTop: 20 }}>
                <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>Monthly Pass:</Typography>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                    <FormControlLabel control={<Checkbox
                        checked={allow_edit_monthly_pass === 1 ? true : false}
                        onChange={(event) => set_allow_edit_monthly_pass(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Edit Monthly Pass" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_pass_delete === 1 ? true : false}
                        onChange={(event) => set_allow_pass_delete(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Pass Delete" />

                    <FormControlLabel control={<Checkbox
                        checked={allow_pass_recharge === 1 ? true : false}
                        onChange={(event) => set_allow_pass_recharge(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Pass Recharge" />
                    <FormControlLabel control={<Checkbox
                        checked={show_monthly_pass === 1 ? true : false}
                        onChange={(event) => set_show_monthly_pass(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Monthly Pass" />
                    <FormControlLabel control={<Checkbox
                        checked={show_monthly_pass_log === 1 ? true : false}
                        onChange={(event) => set_show_monthly_pass_log(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Monthly Pass Log" />
                    <FormControlLabel control={<Checkbox
                        checked={show_monthlypass_request === 1 ? true : false}
                        onChange={(event) => set_show_monthlypass_request(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Monthly Pass Request" />
                </div>
            </div>


            <div style={{ marginTop: 20 }}>
                <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>Parking:</Typography>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                    <FormControlLabel control={<Checkbox
                        checked={allow_current_vehicles_update === 1 ? true : false}
                        onChange={(event) => set_allow_current_vehicles_update(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Current Vehicle Update" />
                    <FormControlLabel control={<Checkbox
                        checked={show_avg_summary_amount === 1 ? true : false}
                        onChange={(event) => set_show_avg_summary_amount(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Avg. Summary Amount" />
                    <FormControlLabel control={<Checkbox
                        checked={show_paid_unpaid_amount === 1 ? true : false}
                        onChange={(event) => set_show_paid_unpaid_amount(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Paid Unpaid Amount" />
                    <FormControlLabel control={<Checkbox
                        checked={show_time_till_seconds === 1 ? true : false}
                        onChange={(event) => set_show_time_till_seconds(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Time Till Seconds" />
                    <FormControlLabel control={<Checkbox
                        checked={show_dashboard_summary === 1 ? true : false}
                        onChange={(event) => set_show_dashboard_summary(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Dashboard Summary" />

                </div>
            </div>

            <div style={{ marginTop: 20 }}>
                <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>General:</Typography>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                    <FormControlLabel control={<Checkbox
                        checked={all_parkings_details === 1 ? true : false}
                        onChange={(event) => set_all_parkings_details(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="All Parkings Logs" />
                    <FormControlLabel control={<Checkbox
                        checked={show_inventory === 1 ? true : false}
                        onChange={(event) => set_show_inventory(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Inventory" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_inventory === 1 ? true : false}
                        onChange={(event) => set_show_rfid_inventory(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID Inventory" />
                    <FormControlLabel control={<Checkbox
                        checked={show_parking_slot_bookings === 1 ? true : false}
                        onChange={(event) => set_show_parking_slot_bookings(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Parking Slot Booking" />
                    <FormControlLabel control={<Checkbox
                        checked={show_operator === 1 ? true : false}
                        onChange={(event) => set_show_operator(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Operator" />
                    <FormControlLabel control={<Checkbox
                        checked={show_verify_vehicle === 1 ? true : false}
                        onChange={(event) => set_show_verify_vehicle(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Verify Vehicle" />
                    <FormControlLabel control={<Checkbox
                        checked={show_parking_controllers === 1 ? true : false}
                        onChange={(event) => set_show_parking_controllers(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Parking Controllers" />
                    <FormControlLabel control={<Checkbox
                        checked={show_device_wallet === 1 ? true : false}
                        onChange={(event) => set_show_device_wallet(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Device Wallet" />
                    <FormControlLabel control={<Checkbox
                        checked={show_exempted_vehicles === 1 ? true : false}
                        onChange={(event) => set_show_exempted_vehicles(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Exempted Vehicles" />
                    <FormControlLabel control={<Checkbox
                        checked={hide_parking_led === 1 ? true : false}
                        onChange={(event) => set_hide_parking_led(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Hide Parking Led" />

                    <FormControlLabel control={<Checkbox
                        checked={hide_parking_section === 1 ? true : false}
                        onChange={(event) => set_hide_parking_section(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Hide Parking Section" />
                    <FormControlLabel control={<Checkbox
                        checked={hide_device_issues === 1 ? true : false}
                        onChange={(event) => set_hide_device_issues(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Hide Device Issues" />

                    <FormControlLabel control={<Checkbox
                        checked={hide_operator_users === 1 ? true : false}
                        onChange={(event) => set_hide_operator_users(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Hide Operator Users" />

                    <FormControlLabel control={<Checkbox
                        checked={hide_parking_details === 1 ? true : false}
                        onChange={(event) => set_hide_parking_details(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Hide Parking Details" />
                    <FormControlLabel control={<Checkbox
                        checked={hide_vehicle_database === 1 ? true : false}
                        onChange={(event) => set_hide_vehicle_database(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Hide Vehicle Database" />
                    <FormControlLabel control={<Checkbox
                        checked={show_vaccine_drive === 1 ? true : false}
                        onChange={(event) => set_show_vaccine_drive(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Vaccine Drive" />
                    <FormControlLabel control={<Checkbox
                        checked={view_only === 1 ? true : false}
                        onChange={(event) => set_view_only(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="View Only" />
                    <FormControlLabel control={<Checkbox
                        checked={show_visitor_logs === 1 ? true : false}
                        onChange={(event) => set_show_visitor_logs(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Visitor Logs" />
                    <FormControlLabel control={<Checkbox
                        checked={show_ieems_section === 1 ? true : false}
                        onChange={(event) => set_show_ieems_section(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show IEEMS Section" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_logs === 1 ? true : false}
                        onChange={(event) => set_show_rfid_logs(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID Logs" />
                    <FormControlLabel control={<Checkbox
                        checked={show_company_column === 1 ? true : false}
                        onChange={(event) => set_show_company_column(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Company Column" />
                    <FormControlLabel control={<Checkbox
                        checked={show_clients_info === 1 ? true : false}
                        onChange={(event) => set_show_clients_info(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Client Info" />
                    <FormControlLabel control={<Checkbox
                        checked={show_dashboard_users === 1 ? true : false}
                        onChange={(event) => set_show_dashboard_users(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Dashboard Users" />

                    <FormControlLabel control={<Checkbox
                        checked={show_card_inventory === 1 ? true : false}
                        onChange={(event) => set_show_card_inventory(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Card Inventory" />
                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_deleted_details === 1 ? true : false}
                        onChange={(event) => set_show_rfid_deleted_details(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show RFID Deleted Details" />
                    <FormControlLabel control={<Checkbox
                        checked={show_site_audits === 1 ? true : false}
                        onChange={(event) => set_show_site_audits(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Site Audits" />
                    <FormControlLabel control={<Checkbox
                        checked={show_warrior_users === 1 ? true : false}
                        onChange={(event) => set_show_warrior_users(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Warrior Users" />
                    <FormControlLabel control={<Checkbox
                        checked={show_device_issues === 1 ? true : false}
                        onChange={(event) => set_show_device_issues(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Device Issues" />
                    <FormControlLabel control={<Checkbox
                        checked={show_map_view === 1 ? true : false}
                        onChange={(event) => set_show_map_view(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Map View" />
                    <FormControlLabel control={<Checkbox
                        checked={show_parking_details === 1 ? true : false}
                        onChange={(event) => set_show_parking_details(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Parking Detials" />
                    <FormControlLabel control={<Checkbox
                        checked={show_dashboard_logs === 1 ? true : false}
                        onChange={(event) => set_show_dashboard_logs(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Dashboard Logs" />
                    <FormControlLabel control={<Checkbox
                        checked={show_fastag_api_data === 1 ? true : false}
                        onChange={(event) => set_show_fastag_api_data(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Fastag API Data" />
                    <FormControlLabel control={<Checkbox
                        checked={show_onboard_users === 1 ? true : false}
                        onChange={(event) => set_show_onboard_users(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Onboard Users" />
                    <FormControlLabel control={<Checkbox
                        checked={show_parking_terminals === 1 ? true : false}
                        onChange={(event) => set_show_parking_terminals(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Parking Terminals" />
                    <FormControlLabel control={<Checkbox checked={allow_create_parking === 1 ? true : false} onChange={(event) => set_allow_create_parking(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                        label="Allow Parking Create" />
                    <FormControlLabel control={<Checkbox checked={allow_download_parkings === 1 ? true : false} onChange={(event) => set_allow_download_parkings(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                        label="Allow Parking Download" />
                    <FormControlLabel control={<Checkbox checked={allow_update_parking === 1 ? true : false} onChange={(event) => set_allow_update_parking(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                        label="Allow Parking Settings" />
                    <FormControlLabel control={<Checkbox checked={allow_parking_led_settings === 1 ? true : false} onChange={(event) => set_allow_parking_led_settings(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                        label="Allow Parking LED Settings" />
                    <FormControlLabel control={<Checkbox checked={allow_parking_info_edit === 1 ? true : false} onChange={(event) => set_allow_parking_info_edit(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                        label="Allow Parking Info Edit" />
                    <FormControlLabel control={<Checkbox checked={allow_parking_license_update === 1 ? true : false} onChange={(event) => set_allow_parking_license_update(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                        label="Allow Parking License Update" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_parking_status_toggle === 1 ? true : false}
                        onChange={(event) => set_allow_parking_status_toggle(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Parking Status Toggle" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_terminal_edit === 1 ? true : false}
                        onChange={(event) => set_allow_terminal_edit(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Terminal Edit" />
                    <FormControlLabel control={<Checkbox
                        checked={show_parking_analytics === 1 ? true : false}
                        onChange={(event) => set_show_parking_analytics(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Parking Analytics" />
                    <FormControlLabel control={<Checkbox
                        checked={create_without_terminal === 1 ? true : false}
                        onChange={(event) => set_create_without_terminal(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Create Without Terminal" />
                    <FormControlLabel control={<Checkbox
                        checked={allow_terminal_device_changes === 1 ? true : false}
                        onChange={(event) => set_allow_terminal_device_changes(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Allow Terminal & Operator Device Changes" />
                    <FormControlLabel control={<Checkbox
                        checked={show_purchased_fastag === 1 ? true : false}
                        onChange={(event) => set_show_purchased_fastag(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Purchased Fastag" />
                    <FormControlLabel control={<Checkbox
                        checked={create_permit_without_mobile === 1 ? true : false}
                        onChange={(event) => set_create_permit_without_mobile(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Create Permit Without Mobile" />
                    <FormControlLabel control={<Checkbox
                        checked={show_cameras === 1 ? true : false}
                        onChange={(event) => set_show_cameras(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Cameras" />
                    <FormControlLabel control={<Checkbox
                        checked={separate_summary_of_devices === 1 ? true : false}
                        onChange={(event) => set_separate_summary_of_devices(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Separate Summary of Devices" />
                    <FormControlLabel
                        control={<Checkbox
                            checked={use_24_hour_format === 1 ? true : false}
                            onChange={(event) => set_use_24_hour_format(event.target.checked === true ? 1 : 0)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        label="Use 24hr Format"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            checked={show_surveillance_images === 1 ? true : false}
                            onChange={(event) => set_show_surveillance_images(event.target.checked === true ? 1 : 0)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        label="Show Surveillance Images"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            checked={use_latest_version === 1 ? true : false}
                            onChange={(event) => set_use_latest_version(event.target.checked === true ? 1 : 0)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        label="Use Latest Version"
                    />
                    <FormControlLabel control={<Checkbox
                        checked={show_anpr_raw_image === 1 ? true : false}
                        onChange={(event) => set_show_anpr_raw_image(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show ANPR Raw Images" />
                    <FormControlLabel control={<Checkbox
                        checked={make_exit_free === 1 ? true : false}
                        onChange={(event) => set_make_exit_free(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Make Exit Free" />

                    <FormControlLabel control={<Checkbox
                        checked={show_reports === 1 ? true : false}
                        onChange={(event) => set_show_reports(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Reports" />


                    <FormControlLabel control={<Checkbox
                        checked={show_patrolling === 1 ? true : false}
                        onChange={(event) => set_show_patrolling(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Patrolling" />


                    <FormControlLabel control={<Checkbox
                        checked={separate_entry_exit_images === 1 ? true : false}
                        onChange={(event) => set_separate_entry_exit_images(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Separate Entry Exit Images" />


                    <FormControlLabel control={<Checkbox
                        checked={vehicle_mobile_mask === 1 ? true : false}
                        onChange={(event) => set_vehicle_mobile_mask(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Vehicle & Mobile Mask" />

                    <FormControlLabel control={<Checkbox
                        checked={check_vehicle_exit === 1 ? true : false}
                        onChange={(event) => set_check_vehicle_exit(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Check Vehicle Exit" />
                    <FormControlLabel control={<Checkbox
                        checked={demo_access === 1 ? true : false}
                        onChange={(event) => set_demo_access(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Demo Access" />
                    <FormControlLabel control={<Checkbox
                        checked={create_sub_user === 1 ? true : false}
                        onChange={(event) => set_create_sub_user(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Create Sub User" />

                    <FormControlLabel control={<Checkbox
                        checked={show_qr_transactions === 1 ? true : false}
                        onChange={(event) => set_show_qr_transactions(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show QR Transactions" />

                    <FormControlLabel control={<Checkbox
                        checked={show_rfid_payments === 1 ? true : false}
                        onChange={(event) => set_show_rfid_payments(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Permit Payments" />

                    <FormControlLabel control={<Checkbox
                        checked={show_anpr_options === 1 ? true : false}
                        onChange={(event) => set_show_anpr_options(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show ANPR Options" />

                    <FormControlLabel control={<Checkbox
                        checked={show_ramp_entry === 1 ? true : false}
                        onChange={(event) => set_show_ramp_entry(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Ramp Entry" />

                    <FormControlLabel control={<Checkbox
                        checked={show_floor_occupancy === 1 ? true : false}
                        onChange={(event) => set_show_floor_occupancy(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Floot Occupancy" />

                    <FormControlLabel control={<Checkbox
                        checked={vehicle_summary_mask === 1 ? true : false}
                        onChange={(event) => set_vehicle_summary_mask(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Vehicle Summary Mask" />
                    <FormControlLabel control={<Checkbox
                        checked={show_dashboard_categories === 1 ? true : false}
                        onChange={(event) => set_show_dashboard_categories(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Dashboard Categories" />
                    <FormControlLabel control={<Checkbox
                        checked={show_currently_parked === 1 ? true : false}
                        onChange={(event) => set_show_currently_parked(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Currently Parked" />
                    <FormControlLabel control={<Checkbox
                        checked={show_settlements === 1 ? true : false}
                        onChange={(event) => set_show_settlements(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Show Settlements" />

                    <FormControlLabel control={<Checkbox
                        checked={edit_device_limit === 1 ? true : false}
                        onChange={(event) => set_edit_device_limit(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Edit Device Limit" />

                    <FormControlLabel control={<Checkbox
                        checked={slot_name_required === 1 ? true : false}
                        onChange={(event) => set_slot_name_required(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Slot Name Required" />

                    <FormControlLabel control={<Checkbox
                        checked={restrict_permits === 1 ? true : false}
                        onChange={(event) => set_restrict_permits(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                        label="Restrict Permits" />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={disable_downloads === 1}
                                onChange={(event) => set_disable_downloads(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Disable Downloads"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={allow_visitor_delete === 1}
                                onChange={(event) => set_allow_visitor_delete(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Allow Visitor Delete"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={allow_client_view === 1}
                                onChange={(event) => set_allow_client_view(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Allow Client View"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_summary_search === 1}
                                onChange={(event) => set_hide_summary_search(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Summary Search"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_barrier_activity === 1}
                                onChange={(event) => set_show_barrier_activity(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Barrier Activity"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_pucc_validity === 1}
                                onChange={(event) => set_show_pucc_validity(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show PUCC Validity"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_dashboard_insights === 1}
                                onChange={(event) => set_show_dashboard_insights(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Dashboard Insights"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_date_wise_filter === 1}
                                onChange={(event) => set_hide_date_wise_filter(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Date Wise Filter"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_monthly_wise_date_filter === 1}
                                onChange={(event) => set_hide_monthly_wise_date_filter(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Monthly Wise Filter"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_custom_date_filter === 1}
                                onChange={(event) => set_hide_custom_date_filter(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Custom Date Filter"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_time_filter === 1}
                                onChange={(event) => set_hide_time_filter(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Time Filter"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={date_till_yesterday === 1}
                                onChange={(event) => set_date_till_yesterday(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Date Till Yesterday"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_qr_codes === 1}
                                onChange={(event) => set_show_qr_codes(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show QR Codes"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_valet_bookings === 1}
                                onChange={(event) => set_show_valet_bookings(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Valet Bookings"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_missed_visitors === 1}
                                onChange={(event) => set_show_missed_visitors(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Missed Visitors"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_apartment_as_unit === 1}
                                onChange={(event) => set_show_apartment_as_unit(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Apartment as Unit"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={only_allow_day_permit === 1}
                                onChange={(event) => set_only_allow_day_permit(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Only Allow Day Permit"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_resources === 1}
                                onChange={(event) => set_hide_resources(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Resources"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_contact_us === 1}
                                onChange={(event) => set_hide_contact_us(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Contact Us"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_linked_permit_logs === 1}
                                onChange={(event) => set_show_linked_permit_logs(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Linked Permit Logs"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_permit_validity_toggle === 1}
                                onChange={(event) => set_show_permit_validity_toggle(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Permit Validity Toggle"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_permit_amount_details === 1}
                                onChange={(event) => set_hide_permit_amount_details(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Permit Amount Details"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_billing_invocies === 1}
                                onChange={(event) => set_show_billing_invocies(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Billing Invoices"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_invoices_user_permits === 1}
                                onChange={(event) => set_show_invoices_user_permits(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Invoices User Permits"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_invoices_vaahan_api === 1}
                                onChange={(event) => set_show_invoices_vaahan_api(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Invoices Vaahan API"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={allow_add_inventory_tags === 1}
                                onChange={(event) => set_allow_add_inventory_tags(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Allow Add Inventory Tags"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_permit_user_bulk_action === 1}
                                onChange={(event) => set_hide_permit_user_bulk_action(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Permit User Bulk Action"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_change_password === 1}
                                onChange={(event) => set_hide_change_password(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Change Password"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_permit_users_filter === 1}
                                onChange={(event) => set_hide_permit_users_filter(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Permit Users Filter"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={only_show_vehicle_search === 1}
                                onChange={(event) => set_only_show_vehicle_search(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Only Show Vehicle Search"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hide_unnecessary_permit_users_column === 1}
                                onChange={(event) => set_hide_unnecessary_permit_users_column(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Hide Unnecessary Permit Users Column"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_tutorial === 1}
                                onChange={(event) => set_show_tutorial(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Tutorial"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_vehicle_not_registered_msg === 1}
                                onChange={(event) => set_show_vehicle_not_registered_msg(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Vehicle Not Registered Message"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_searched_data_only === 1}
                                onChange={(event) => set_show_searched_data_only(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Searched Data Only"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_permit_defaulter === 1}
                                onChange={(event) => set_show_permit_defaulter(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Permit Defaulter"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_grace_period === 1}
                                onChange={(event) => set_show_grace_period(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Grace Period"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_grace_period_logs === 1}
                                onChange={(event) => set_show_grace_period_logs(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Grace Period Logs"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_grace_period_configurations === 1}
                                onChange={(event) => set_show_grace_period_configurations(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Grace Period Configurations"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_billings_maintenance_plan === 1}
                                onChange={(event) => set_show_billings_maintenance_plan(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Billings Maintenance Plan"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_floor_occupancy_edit === 1}
                                onChange={(event) => set_show_floor_occupancy_edit(event.target.checked ? 1 : 0)}
                            />
                        }
                        label="Show Floor Occupancy Edit"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_operator_devices === 1 ? true : false}
                                onChange={(event) =>
                                    set_show_operator_devices(event.target.checked === true ? 1 : 0)
                                }
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Show Operator Devices"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_operator_shifts === 1 ? true : false}
                                onChange={(event) =>
                                    set_show_operator_shifts(event.target.checked === true ? 1 : 0)
                                }
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Show Operator Shifts"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_operator_users === 1 ? true : false}
                                onChange={(event) =>
                                    set_show_operator_users(event.target.checked === true ? 1 : 0)
                                }
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Show Operator Users"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={auto_refresh_vehicle_summary === 1 ? true : false}
                                onChange={(event) =>
                                    set_auto_refresh_vehicle_summary(event.target.checked === true ? 1 : 0)
                                }
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Auto Refresh Vehicle Summary"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={show_start_end_date_pairing_input === 1 ? true : false}
                                onChange={(event) =>
                                    set_show_start_end_date_pairing_input(event.target.checked === true ? 1 : 0)
                                }
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Show Start End Date Pairing"
                    />

                </div>
            </div>

        </>
    </div>
}


export const CrmUserEdit = ({ permissions, ...props }) => {
    const eventTracker = UseAnalyticsEvent()

    const optionRenderer = choice => choice ? `${choice.name} : ${choice.access_key} ` : '';

    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    React.useEffect(() => {
        eventTracker(CATEGORY, "EDIT DASHBOARD USER")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Edit title='Edit CRM User' {...props} undoable={false} onFailure={onFailure} onSuccess={onSuccess}>
            <SimpleForm redirect="list" validate={validateUserEdit} toolbar={<CustomToolbar />}>

                <TextInput source="username" variant="outlined" disabled />
                <TextInput source="email" variant="outlined" />
                <TextInput source="mobile" variant="outlined" />
                <CustomEditPasswordField />

                {permissions === 'admin' ? <RadioButtonGroupInput source="role" choices={choices} optionText="name" optionValue="id" /> : <RadioButtonGroupInput source="role" choices={choicesContractor} optionText="name" optionValue="id" />}
                <FormDataConsumer>
                    {({ formData, ...rest }) => {
                        return (
                            <AutocompleteArrayInput label="Remove Parking Access Keys" choices={formData.access_keys} source="remove_access_keys" optionText={optionRenderer} options={{ suggestionsContainerProps: { placement: "bottom-start" } }} variant="outlined" />
                        )
                    }}
                </FormDataConsumer>
                <FormDataConsumer>
                    {({ formData, ...rest }) => (
                        <RaAutocompleteInput
                            multiple={true}
                            source="assign_access_keys"
                            resourceParam="name"
                            resourcePath="uniqueParkingAccessKeys"
                            label="Assign Parkings"
                            getOptionValue={option => option["id"]}
                            getOptionLabel={optionRenderer}
                            style={{ marginTop: 10, marginBottom: 20, maxWidth: 350 }}
                            filterOptions={(options) => options.filter(choice => (!formData.access_keys || formData.access_keys.findIndex(p => p.access_key === choice.access_key)) === -1)}
                        />
                    )}
                </FormDataConsumer>
                <CustomEditForm />
            </SimpleForm>
        </Edit>
    )
}

const choices = [
    { id: 'admin', name: 'Admin' },
    { id: 'sales', name: 'Sales' },
    { id: 'contractor', name: 'Contractor' }
];

const choicesContractor = [
    { id: 'contractor', name: 'Contractor' }
];

const CustomParkingSelector = ({ formData, ...rest }) => {
    const { input: { value: access_key } } = useInput({ ...rest, id: "access_key", source: "access_key" });
    console.log("access_key", access_key)
    return <>
        {formData.role !== "admin" && <div>
            <RaAutocompleteInput
                {...rest}
                multiple={true}
                source="access_key"
                resourceParam="name"
                resourcePath="uniqueParkingAccessKeys"
                label="Parkings"
                getOptionValue={option => option["id"]}
                getOptionLabel={option => `${option["name"]} : ${option["access_key"]}`}
                style={{ marginTop: 10, marginBottom: 20, maxWidth: 350 }}
            />
            {(!access_key || access_key.length === 0) && <p style={{ fontSize: 12.5, fontWeight: 600, color: "#de575e", marginLeft: 14, marginTop: -13 }}>Parking is required</p>}
        </div>}
    </>
};


const CreateCustomToolbar = (props) => {

    return <Toolbar {...props} >
        <SaveButton disableElevation style={{ marginTop: 15 }} />
    </Toolbar>
}

const CustomCreateForm = (props) => {
    const { input: { value: allow_unallocated_rfid, onChange: set_allow_unallocated_rfid } } = useInput({ ...props, id: "allow_unallocated_rfid", source: "allow_unallocated_rfid" });
    const { input: { value: all_parkings_details, onChange: set_all_parkings_details } } = useInput({ ...props, id: "all_parkings_details", source: "all_parkings_details" });
    const { input: { value: allow_company_user_create, onChange: set_allow_company_user_create } } = useInput({ ...props, id: "allow_company_user_create", source: "allow_company_user_create" });
    const { input: { value: allow_current_vehicles_update, onChange: set_allow_current_vehicles_update } } = useInput({ ...props, id: "allow_current_vehicles_update", source: "allow_current_vehicles_update" });
    const { input: { value: allow_edit_monthly_pass, onChange: set_allow_edit_monthly_pass } } = useInput({ ...props, id: "allow_edit_monthly_pass", source: "allow_edit_monthly_pass" });
    const { input: { value: allow_fastag, onChange: set_allow_fastag } } = useInput({ ...props, id: "allow_fastag", source: "allow_fastag" });
    const { input: { value: allow_pass_delete, onChange: set_allow_pass_delete } } = useInput({ ...props, id: "allow_pass_delete", source: "allow_pass_delete" });
    const { input: { value: allow_pass_recharge, onChange: set_allow_pass_recharge } } = useInput({ ...props, id: "allow_pass_recharge", source: "allow_pass_recharge" });
    const { input: { value: allow_rfid_create, onChange: set_allow_rfid_create } } = useInput({ ...props, id: "allow_rfid_create", source: "allow_rfid_create" });
    const { input: { value: allow_rfid_delete, onChange: set_allow_rfid_delete } } = useInput({ ...props, id: "allow_rfid_delete", source: "allow_rfid_delete" });
    const { input: { value: company_user, onChange: set_company_user } } = useInput({ ...props, id: "company_user", source: "company_user" });
    const { input: { value: create_permit_name_required, onChange: set_create_permit_name_required } } = useInput({ ...props, id: "create_permit_name_required", source: "create_permit_name_required" });
    const { input: { value: hide_device_issues, onChange: set_hide_device_issues } } = useInput({ ...props, id: "hide_device_issues", source: "hide_device_issues" });

    const { input: { value: hide_operator_users, onChange: set_hide_operator_users } } = useInput({ ...props, id: "hide_operator_users", source: "hide_operator_users" });
    const { input: { value: hide_parking_details, onChange: set_hide_parking_details } } = useInput({ ...props, id: "hide_parking_details", source: "hide_parking_details" });
    const { input: { value: hide_parking_led, onChange: set_hide_parking_led } } = useInput({ ...props, id: "hide_parking_led", source: "hide_parking_led" });
    const { input: { value: hide_parking_section, onChange: set_hide_parking_section } } = useInput({ ...props, id: "hide_parking_section", source: "hide_parking_section" });
    const { input: { value: hide_vehicle_database, onChange: set_hide_vehicle_database } } = useInput({ ...props, id: "hide_vehicle_database", source: "hide_vehicle_database" });
    const { input: { value: show_avg_summary_amount, onChange: set_show_avg_summary_amount } } = useInput({ ...props, id: "show_avg_summary_amount", source: "show_avg_summary_amount" });
    const { input: { value: show_device_wallet, onChange: set_show_device_wallet } } = useInput({ ...props, id: "show_device_wallet", source: "show_device_wallet" });
    const { input: { value: show_exempted_vehicles, onChange: set_show_exempted_vehicles } } = useInput({ ...props, id: "show_exempted_vehicles", source: "show_exempted_vehicles" });
    const { input: { value: show_fastag_payment, onChange: set_show_fastag_payment } } = useInput({ ...props, id: "show_fastag_payment", source: "show_fastag_payment" });
    const { input: { value: show_flat_details, onChange: set_show_flat_details } } = useInput({ ...props, id: "show_flat_details", source: "show_flat_details" });
    const { input: { value: show_inventory, onChange: set_show_inventory } } = useInput({ ...props, id: "show_inventory", source: "show_inventory" });
    const { input: { value: show_monthly_pass, onChange: set_show_monthly_pass } } = useInput({ ...props, id: "show_monthly_pass", source: "show_monthly_pass" });
    const { input: { value: show_monthly_pass_log, onChange: set_show_monthly_pass_log } } = useInput({ ...props, id: "show_monthly_pass_log", source: "show_monthly_pass_log" });
    const { input: { value: show_monthlypass_request, onChange: set_show_monthlypass_request } } = useInput({ ...props, id: "show_monthlypass_request", source: "show_monthlypass_request" });
    const { input: { value: show_operator, onChange: set_show_operator } } = useInput({ ...props, id: "show_operator", source: "show_operator" });
    const { input: { value: show_paid_unpaid_amount, onChange: set_show_paid_unpaid_amount } } = useInput({ ...props, id: "show_paid_unpaid_amount", source: "show_paid_unpaid_amount" });
    const { input: { value: show_parking_controllers, onChange: set_show_parking_controllers } } = useInput({ ...props, id: "show_parking_controllers", source: "show_parking_controllers" });
    const { input: { value: show_parking_slot_bookings, onChange: set_show_parking_slot_bookings } } = useInput({ ...props, id: "show_parking_slot_bookings", source: "show_parking_slot_bookings" });
    const { input: { value: show_permit_apartments, onChange: set_show_permit_apartments } } = useInput({ ...props, id: "show_permit_apartments", source: "show_permit_apartments" });
    const { input: { value: show_rfid, onChange: set_show_rfid } } = useInput({ ...props, id: "show_rfid", source: "show_rfid" });
    const { input: { value: show_rfid_column, onChange: set_show_rfid_column } } = useInput({ ...props, id: "show_rfid_column", source: "show_rfid_column" });
    const { input: { value: show_rfid_company, onChange: set_show_rfid_company } } = useInput({ ...props, id: "show_rfid_company", source: "show_rfid_company" });
    const { input: { value: show_rfid_inventory, onChange: set_show_rfid_inventory } } = useInput({ ...props, id: "show_rfid_inventory", source: "show_rfid_inventory" });
    const { input: { value: show_rfid_recharge, onChange: set_show_rfid_recharge } } = useInput({ ...props, id: "show_rfid_recharge", source: "show_rfid_recharge" });
    const { input: { value: show_rfid_requests, onChange: set_show_rfid_requests } } = useInput({ ...props, id: "show_rfid_requests", source: "show_rfid_requests" });
    const { input: { value: show_tag_column, onChange: set_show_tag_column } } = useInput({ ...props, id: "show_tag_column", source: "show_tag_column" });
    const { input: { value: show_time_till_seconds, onChange: set_show_time_till_seconds } } = useInput({ ...props, id: "show_time_till_seconds", source: "show_time_till_seconds" });
    const { input: { value: show_vaccine_drive, onChange: set_show_vaccine_drive } } = useInput({ ...props, id: "show_vaccine_drive", source: "show_vaccine_drive" });
    const { input: { value: show_validity_column, onChange: set_show_validity_column } } = useInput({ ...props, id: "show_validity_column", source: "show_validity_column" });
    const { input: { value: show_verify_vehicle, onChange: set_show_verify_vehicle } } = useInput({ ...props, id: "show_verify_vehicle", source: "show_verify_vehicle" });
    const { input: { value: view_only, onChange: set_view_only } } = useInput({ ...props, id: "view_only", source: "view_only" });
    const { input: { value: rfid_validity_default, onChange: set_rfid_validity_default } } = useInput({ ...props, id: "rfid_validity_default", source: "rfid_validity_default" });
    const { input: { value: parking_type } } = useInput({ ...props, id: "parking_type", source: "parking_type" });


    const { input: { value: show_edit_configuration, onChange: set_show_edit_configuration } } = useInput({ ...props, id: "show_edit_configuration", source: "show_edit_configuration" });
    const { input: { value: show_resources_separately, onChange: set_show_resources_separately } } = useInput({ ...props, id: "show_resources_separately", source: "show_resources_separately" });
    const { input: { value: show_profile, onChange: set_show_profile } } = useInput({ ...props, id: "show_profile", source: "show_profile" });
    const { input: { value: show_visitor_logs, onChange: set_show_visitor_logs } } = useInput({ ...props, id: "show_visitor_logs", source: "show_visitor_logs" });

    const { input: { value: hide_mobile_number, onChange: set_hide_mobile_number } } = useInput({ ...props, id: "hide_mobile_number", source: "hide_mobile_number" });
    const { input: { value: show_reserved_column, onChange: set_show_reserved_column } } = useInput({ ...props, id: "show_reserved_column", source: "show_reserved_column" });
    const { input: { value: show_exit_vehicle_button, onChange: set_show_exit_vehicle_button } } = useInput({ ...props, id: "show_exit_vehicle_button", source: "show_exit_vehicle_button" });
    const { input: { value: show_ieems_section, onChange: set_show_ieems_section } } = useInput({ ...props, id: "show_ieems_section", source: "show_ieems_section" });
    const { input: { value: show_rfid_logs, onChange: set_show_rfid_logs } } = useInput({ ...props, id: "show_rfid_logs", source: "show_rfid_logs" });
    const { input: { value: show_company_column, onChange: set_show_company_column } } = useInput({ ...props, id: "show_company_column", source: "show_company_column" });
    const { input: { value: show_permits, onChange: set_show_permits } } = useInput({ ...props, id: "show_permits", source: "show_permits" });
    const { input: { value: show_clients_info, onChange: set_show_clients_info } } = useInput({ ...props, id: "show_clients_info", source: "show_clients_info" });
    const { input: { value: show_dashboard_users, onChange: set_show_dashboard_users } } = useInput({ ...props, id: "show_dashboard_users", source: "show_dashboard_users" });
    const { input: { value: show_card_inventory, onChange: set_show_card_inventory } } = useInput({ ...props, id: "show_card_inventory", source: "show_card_inventory" });
    const { input: { value: show_rfid_deleted_details, onChange: set_show_rfid_deleted_details } } = useInput({ ...props, id: "show_rfid_deleted_details", source: "show_rfid_deleted_details" });
    const { input: { value: show_site_audits, onChange: set_show_site_audits } } = useInput({ ...props, id: "show_site_audits", source: "show_site_audits" });
    const { input: { value: show_warrior_users, onChange: set_show_warrior_users } } = useInput({ ...props, id: "show_warrior_users", source: "show_warrior_users" });
    const { input: { value: show_device_issues, onChange: set_show_device_issues } } = useInput({ ...props, id: "show_device_issues", source: "show_device_issues" });
    const { input: { value: show_map_view, onChange: set_show_map_view } } = useInput({ ...props, id: "show_map_view", source: "show_map_view" });
    const { input: { value: show_parking_details, onChange: set_show_parking_details } } = useInput({ ...props, id: "show_parking_details", source: "show_parking_details" });
    const { input: { value: show_dashboard_logs, onChange: set_show_dashboard_logs } } = useInput({ ...props, id: "show_dashboard_logs", source: "show_dashboard_logs" });
    const { input: { value: show_fastag_api_data, onChange: set_show_fastag_api_data } } = useInput({ ...props, id: "show_fastag_api_data", source: "show_fastag_api_data" });
    const { input: { value: show_onboard_users, onChange: set_show_onboard_users } } = useInput({ ...props, id: "show_onboard_users", source: "show_onboard_users" });
    const { input: { value: show_parking_terminals, onChange: set_show_parking_terminals } } = useInput({ ...props, id: "show_parking_terminals", source: "show_parking_terminals" });
    const { input: { value: allow_create_parking, onChange: set_allow_create_parking } } = useInput({ ...props, id: "allow_create_parking", source: "allow_create_parking" });
    const { input: { value: allow_download_parkings, onChange: set_allow_download_parkings } } = useInput({ ...props, id: "allow_download_parkings", source: "allow_download_parkings" });
    const { input: { value: allow_update_parking, onChange: set_allow_update_parking } } = useInput({ ...props, id: "allow_update_parking", source: "allow_update_parking" });
    const { input: { value: allow_parking_led_settings, onChange: set_allow_parking_led_settings } } = useInput({ ...props, id: "allow_parking_led_settings", source: "allow_parking_led_settings" });
    const { input: { value: allow_parking_info_edit, onChange: set_allow_parking_info_edit } } = useInput({ ...props, id: "allow_parking_info_edit", source: "allow_parking_info_edit" });
    const { input: { value: allow_parking_license_update, onChange: set_allow_parking_license_update } } = useInput({ ...props, id: "allow_parking_license_update", source: "allow_parking_license_update" });
    const { input: { value: allow_parking_status_toggle, onChange: set_allow_parking_status_toggle } } = useInput({ ...props, id: "allow_parking_status_toggle", source: "allow_parking_status_toggle" });
    const { input: { value: allow_terminal_edit, onChange: set_allow_terminal_edit } } = useInput({ ...props, id: "allow_terminal_edit", source: "allow_terminal_edit" });
    const { input: { value: show_parking_analytics, onChange: set_show_parking_analytics } } = useInput({ ...props, id: "show_parking_analytics", source: "show_parking_analytics" });
    const { input: { value: show_dashboard_summary, onChange: set_show_dashboard_summary } } = useInput({ ...props, id: "show_dashboard_summary", source: "show_dashboard_summary" });
    const { input: { value: create_without_terminal, onChange: set_create_without_terminal } } = useInput({ ...props, id: "create_without_terminal", source: "create_without_terminal" });
    const { input: { value: allow_terminal_device_changes, onChange: set_allow_terminal_device_changes } } = useInput({ ...props, id: "allow_terminal_device_changes", source: "allow_terminal_device_changes" });
    const { input: { value: show_purchased_fastag, onChange: set_show_purchased_fastag } } = useInput({ ...props, id: "show_purchased_fastag", source: "show_purchased_fastag" });
    const { input: { value: create_permit_without_mobile, onChange: set_create_permit_without_mobile } } = useInput({ ...props, id: "create_permit_without_mobile", source: "create_permit_without_mobile" });
    const { input: { value: show_cameras, onChange: set_show_cameras } } = useInput({ ...props, id: "show_cameras", source: "show_cameras" });
    const { input: { value: separate_summary_of_devices, onChange: set_separate_summary_of_devices } } = useInput({ ...props, id: "separate_summary_of_devices", source: "separate_summary_of_devices" });
    const { input: { value: use_24_hour_format, onChange: set_use_24_hour_format } } = useInput({ ...props, id: "use_24_hour_format", source: "use_24_hour_format" });
    const { input: { value: show_surveillance_images, onChange: set_show_surveillance_images } } = useInput({ ...props, id: "show_surveillance_images", source: "show_surveillance_images" });
    const { input: { value: use_latest_version, onChange: set_use_latest_version } } = useInput({ ...props, id: "use_latest_version", source: "use_latest_version" });

    const { input: { value: show_anpr_raw_image, onChange: set_show_anpr_raw_image } } = useInput({ ...props, id: "show_anpr_raw_image", source: "show_anpr_raw_image" });
    const { input: { value: make_exit_free, onChange: set_make_exit_free } } = useInput({ ...props, id: "make_exit_free", source: "make_exit_free" });
    const { input: { value: show_reports, onChange: set_show_reports } } = useInput({ ...props, id: "show_reports", source: "show_reports" });
    const { input: { value: show_patrolling, onChange: set_show_patrolling } } = useInput({ ...props, id: "show_patrolling", source: "show_patrolling" });
    const { input: { value: separate_entry_exit_images, onChange: set_separate_entry_exit_images } } = useInput({ ...props, id: "separate_entry_exit_images", source: "separate_entry_exit_images" });
    const { input: { value: vehicle_mobile_mask, onChange: set_vehicle_mobile_mask } } = useInput({ ...props, id: "vehicle_mobile_mask", source: "vehicle_mobile_mask" });
    const { input: { value: check_vehicle_exit, onChange: set_check_vehicle_exit } } = useInput({ ...props, id: "check_vehicle_exit", source: "check_vehicle_exit" });
    const { input: { value: demo_access, onChange: set_demo_access } } = useInput({ ...props, id: "demo_access", source: "demo_access" });

    const { input: { value: create_sub_user, onChange: set_create_sub_user } } = useInput({ ...props, id: "create_sub_user", source: "create_sub_user" });
    const { input: { value: show_qr_transactions, onChange: set_show_qr_transactions } } = useInput({ ...props, id: "show_qr_transactions", source: "show_qr_transactions" });
    const { input: { value: show_rfid_payments, onChange: set_show_rfid_payments } } = useInput({ ...props, id: "show_rfid_payments", source: "show_rfid_payments" });
    const { input: { value: show_anpr_options, onChange: set_show_anpr_options } } = useInput({ ...props, id: "show_anpr_options", source: "show_anpr_options" });
    const { input: { value: show_ramp_entry, onChange: set_show_ramp_entry } } = useInput({ ...props, id: "show_ramp_entry", source: "show_ramp_entry" });
    const { input: { value: show_floor_occupancy, onChange: set_show_floor_occupancy } } = useInput({ ...props, id: "show_floor_occupancy", source: "show_floor_occupancy" });
    const { input: { value: vehicle_summary_mask, onChange: set_vehicle_summary_mask } } = useInput({ ...props, id: "vehicle_summary_mask", source: "vehicle_summary_mask" });

    const { input: { value: show_dashboard_categories, onChange: set_show_dashboard_categories } } = useInput({ ...props, id: "show_dashboard_categories", source: "show_dashboard_categories" });
    const { input: { value: show_currently_parked, onChange: set_show_currently_parked } } = useInput({ ...props, id: "show_currently_parked", source: "show_currently_parked" });
    const { input: { value: show_settlements, onChange: set_show_settlements } } = useInput({ ...props, id: "show_settlements", source: "show_settlements" });
    const { input: { value: edit_device_limit, onChange: set_edit_device_limit } } = useInput({ ...props, id: "edit_device_limit", source: "edit_device_limit" });
    const { input: { value: slot_name_required, onChange: set_slot_name_required } } = useInput({ ...props, id: "slot_name_required", source: "slot_name_required" });
    const { input: { value: restrict_permits, onChange: set_restrict_permits } } = useInput({ ...props, id: "restrict_permits", source: "restrict_permits" });
    const { input: { value: disable_downloads, onChange: set_disable_downloads } } = useInput({ ...props, id: "disable_downloads", source: "disable_downloads" });
    const { input: { value: allow_visitor_delete, onChange: set_allow_visitor_delete } } = useInput({ ...props, id: "allow_visitor_delete", source: "allow_visitor_delete" });
    const { input: { value: allow_client_view, onChange: set_allow_client_view } } = useInput({ ...props, id: "allow_client_view", source: "allow_client_view" });
    const { input: { value: hide_summary_search, onChange: set_hide_summary_search } } = useInput({ ...props, id: "hide_summary_search", source: "hide_summary_search" });
    const { input: { value: show_barrier_activity, onChange: set_show_barrier_activity } } = useInput({ ...props, id: "show_barrier_activity", source: "show_barrier_activity" });
    const { input: { value: show_pucc_validity, onChange: set_show_pucc_validity } } = useInput({ ...props, id: "show_pucc_validity", source: "show_pucc_validity" });
    const { input: { value: show_dashboard_insights, onChange: set_show_dashboard_insights } } = useInput({ ...props, id: "show_dashboard_insights", source: "show_dashboard_insights" });
    const { input: { value: hide_date_wise_filter, onChange: set_hide_date_wise_filter } } = useInput({ ...props, id: "hide_date_wise_filter", source: "hide_date_wise_filter" });
    const { input: { value: hide_monthly_wise_date_filter, onChange: set_hide_monthly_wise_date_filter } } = useInput({ ...props, id: "hide_monthly_wise_date_filter", source: "hide_monthly_wise_date_filter" });
    const { input: { value: hide_custom_date_filter, onChange: set_hide_custom_date_filter } } = useInput({ ...props, id: "hide_custom_date_filter", source: "hide_custom_date_filter" });
    const { input: { value: hide_time_filter, onChange: set_hide_time_filter } } = useInput({ ...props, id: "hide_time_filter", source: "hide_time_filter" });
    const { input: { value: date_till_yesterday, onChange: set_date_till_yesterday } } = useInput({ ...props, id: "date_till_yesterday", source: "date_till_yesterday" });
    const { input: { value: show_qr_codes, onChange: set_show_qr_codes } } = useInput({ ...props, id: "show_qr_codes", source: "show_qr_codes" });
    const { input: { value: show_valet_bookings, onChange: set_show_valet_bookings } } = useInput({ ...props, id: "show_valet_bookings", source: "show_valet_bookings" });
    const { input: { value: show_missed_visitors, onChange: set_show_missed_visitors } } = useInput({ ...props, id: "show_missed_visitors", source: "show_missed_visitors" });
    const { input: { value: show_apartment_as_unit, onChange: set_show_apartment_as_unit } } = useInput({ ...props, id: "show_apartment_as_unit", source: "show_apartment_as_unit" });
    const { input: { value: only_allow_day_permit, onChange: set_only_allow_day_permit } } = useInput({ ...props, id: "only_allow_day_permit", source: "only_allow_day_permit" });
    const { input: { value: hide_resources, onChange: set_hide_resources } } = useInput({ ...props, id: "hide_resources", source: "hide_resources" });
    const { input: { value: hide_contact_us, onChange: set_hide_contact_us } } = useInput({ ...props, id: "hide_contact_us", source: "hide_contact_us" });
    const { input: { value: show_linked_permit_logs, onChange: set_show_linked_permit_logs } } = useInput({ ...props, id: "show_linked_permit_logs", source: "show_linked_permit_logs" });
    const { input: { value: show_permit_validity_toggle, onChange: set_show_permit_validity_toggle } } = useInput({ ...props, id: "show_permit_validity_toggle", source: "show_permit_validity_toggle" });
    const { input: { value: hide_permit_amount_details, onChange: set_hide_permit_amount_details } } = useInput({ ...props, id: "hide_permit_amount_details", source: "hide_permit_amount_details" });
    const { input: { value: show_billing_invocies, onChange: set_show_billing_invocies } } = useInput({ ...props, id: "show_billing_invocies", source: "show_billing_invocies" });
    const { input: { value: show_invoices_user_permits, onChange: set_show_invoices_user_permits } } = useInput({ ...props, id: "show_invoices_user_permits", source: "show_invoices_user_permits" });
    const { input: { value: show_invoices_vaahan_api, onChange: set_show_invoices_vaahan_api } } = useInput({ ...props, id: "show_invoices_vaahan_api", source: "show_invoices_vaahan_api" });
    const { input: { value: allow_add_inventory_tags, onChange: set_allow_add_inventory_tags } } = useInput({ ...props, id: "allow_add_inventory_tags", source: "allow_add_inventory_tags" });
    const { input: { value: hide_permit_user_bulk_action, onChange: set_hide_permit_user_bulk_action } } = useInput({ ...props, id: "hide_permit_user_bulk_action", source: "hide_permit_user_bulk_action" });
    const { input: { value: hide_change_password, onChange: set_hide_change_password } } = useInput({ ...props, id: "hide_change_password", source: "hide_change_password" });
    const { input: { value: hide_permit_users_filter, onChange: set_hide_permit_users_filter } } = useInput({ ...props, id: "hide_permit_users_filter", source: "hide_permit_users_filter" });
    const { input: { value: only_show_vehicle_search, onChange: set_only_show_vehicle_search } } = useInput({ ...props, id: "only_show_vehicle_search", source: "only_show_vehicle_search" });
    const { input: { value: hide_unnecessary_permit_users_column, onChange: set_hide_unnecessary_permit_users_column } } = useInput({ ...props, id: "hide_unnecessary_permit_users_column", source: "hide_unnecessary_permit_users_column" });
    const { input: { value: show_tutorial, onChange: set_show_tutorial } } = useInput({ ...props, id: "show_tutorial", source: "show_tutorial" });
    const { input: { value: show_vehicle_not_registered_msg, onChange: set_show_vehicle_not_registered_msg } } = useInput({ ...props, id: "show_vehicle_not_registered_msg", source: "show_vehicle_not_registered_msg" });
    const { input: { value: show_searched_data_only, onChange: set_show_searched_data_only } } = useInput({ ...props, id: "show_searched_data_only", source: "show_searched_data_only" });
    const { input: { value: show_permit_defaulter, onChange: set_show_permit_defaulter } } = useInput({ ...props, id: "show_permit_defaulter", source: "show_permit_defaulter" });
    const { input: { value: show_grace_period, onChange: set_show_grace_period } } = useInput({ ...props, id: "show_grace_period", source: "show_grace_period" });
    const { input: { value: show_grace_period_logs, onChange: set_show_grace_period_logs } } = useInput({ ...props, id: "show_grace_period_logs", source: "show_grace_period_logs" });
    const { input: { value: show_grace_period_configurations, onChange: set_show_grace_period_configurations } } = useInput({ ...props, id: "show_grace_period_configurations", source: "show_grace_period_configurations" });
    const { input: { value: show_billings_maintenance_plan, onChange: set_show_billings_maintenance_plan } } = useInput({ ...props, id: "show_billings_maintenance_plan", source: "show_billings_maintenance_plan" });
    const { input: { value: show_floor_occupancy_edit, onChange: set_show_floor_occupancy_edit } } = useInput({ ...props, id: "show_floor_occupancy_edit", source: "show_floor_occupancy_edit" });
    const { input: { value: show_start_end_date_pairing_input, onChange: set_show_start_end_date_pairing_input } } = useInput({ ...props, id: "show_start_end_date_pairing_input", source: "show_start_end_date_pairing_input" });
    const { input: { value: auto_refresh_vehicle_summary, onChange: set_auto_refresh_vehicle_summary } } = useInput({ ...props, id: "auto_refresh_vehicle_summary", source: "auto_refresh_vehicle_summary" });
    const { input: { value: show_operator_devices, onChange: set_show_operator_devices } } = useInput({ ...props, id: "show_operator_devices", source: "show_operator_devices" });
    const { input: { value: show_operator_shifts, onChange: set_show_operator_shifts } } = useInput({ ...props, id: "show_operator_shifts", source: "show_operator_shifts" });
    const { input: { value: show_operator_users, onChange: set_show_operator_users } } = useInput({ ...props, id: "show_operator_users", source: "show_operator_users" });

    const societyTemplateDefaultFlags = () => {
        set_allow_fastag(1)
        set_allow_rfid_create(1)
        set_allow_rfid_delete(1)
        set_hide_parking_section(1)
        set_hide_vehicle_database(1)
        set_show_flat_details(1)
        set_show_rfid_requests(1)
        set_show_tag_column(1)
        set_show_rfid_company(0)
        set_show_rfid_inventory(1)
        set_show_rfid(1)
        set_show_parking_controllers(1)
        set_show_dashboard_summary(0)
    }

    const defaultFlags = () => {
        set_allow_fastag(0)
        set_allow_rfid_create(0)
        set_allow_rfid_delete(0)
        set_hide_parking_section(0)
        set_hide_vehicle_database(0)
        set_show_flat_details(0)
        set_show_rfid_requests(0)
        set_show_tag_column(0)
        set_show_rfid_company(1)
        set_show_rfid_inventory(0)
        set_show_rfid(0)
        set_show_parking_controllers(0)
        set_show_dashboard_summary(1)
    }

    const commonFlags = () => {
        set_allow_unallocated_rfid(0)
        set_all_parkings_details(0)
        set_allow_company_user_create(0)
        set_allow_current_vehicles_update(0)
        set_allow_edit_monthly_pass(0)
        set_allow_pass_delete(0)
        set_allow_pass_recharge(0)
        set_company_user(0)
        set_create_permit_name_required(0)
        set_hide_device_issues(0)
        set_hide_operator_users(0)
        set_hide_parking_details(0)
        set_hide_parking_led(0)
        set_show_avg_summary_amount(0)
        set_show_device_wallet(0)
        set_show_exempted_vehicles(0)
        set_show_fastag_payment(0)
        set_show_inventory(0)
        set_show_monthly_pass(0)
        set_show_monthly_pass_log(1)
        set_show_monthlypass_request(0)
        set_show_operator(0)
        set_show_paid_unpaid_amount(0)
        set_show_parking_slot_bookings(0)
        set_show_permit_apartments(0)
        set_show_rfid_column(0)
        set_show_rfid_recharge(0)
        set_show_time_till_seconds(0)
        set_show_vaccine_drive(0)
        set_show_validity_column(0)
        set_show_verify_vehicle(0)
        set_view_only(0)
        set_rfid_validity_default(0)
        set_show_resources_separately(0)
        set_show_profile(0)
        set_show_visitor_logs(0)

        set_hide_mobile_number(0)
        set_show_reserved_column(0)
        set_show_exit_vehicle_button(0)
        set_show_ieems_section(0)
        set_show_rfid_logs(0)
        set_show_company_column(0)
        set_show_permits(0)
        set_show_clients_info(0)
        set_show_dashboard_users(0)
        set_show_card_inventory(0)
        set_show_rfid_deleted_details(0)
        set_show_site_audits(0)
        set_show_warrior_users(0)
        set_show_device_issues(0)
        set_show_map_view(0)
        set_show_parking_details(0)
        set_show_dashboard_logs(0)
        set_show_fastag_api_data(0)
        set_show_onboard_users(0)
        set_show_parking_terminals(0)
        set_allow_create_parking(0)
        set_allow_download_parkings(0)
        set_allow_update_parking(0)
        set_allow_parking_led_settings(0)
        set_allow_parking_info_edit(0)
        set_allow_parking_license_update(0)
        set_allow_parking_status_toggle(0)
        set_allow_terminal_edit(0)
        set_show_parking_analytics(0)
        set_create_without_terminal(0)
        set_allow_terminal_device_changes(0)
        set_show_purchased_fastag(0)
        set_create_permit_without_mobile(0)
        set_show_cameras(0)
        set_separate_summary_of_devices(0)
        set_use_24_hour_format(0)
        set_show_surveillance_images(0)
        set_use_latest_version(0)
    }

    const commonAdminFlags = () => {
        set_allow_fastag(1)
        set_allow_rfid_create(1)
        set_allow_rfid_delete(1)
        set_hide_parking_section(0)
        set_hide_vehicle_database(1)
        set_show_flat_details(1)
        set_show_rfid_requests(1)
        set_show_tag_column(1)
        set_show_rfid_company(1)
        set_show_rfid_inventory(1)
        set_show_rfid(1)
        set_show_parking_controllers(1)
        set_allow_unallocated_rfid(0)
        set_all_parkings_details(1)
        set_allow_company_user_create(1)
        set_allow_current_vehicles_update(0)
        set_allow_edit_monthly_pass(1)
        set_allow_pass_delete(1)
        set_allow_pass_recharge(1)
        set_company_user(0)
        set_create_permit_name_required(0)
        set_hide_device_issues(0)
        set_hide_operator_users(0)
        set_hide_parking_details(0)
        set_hide_parking_led(0)
        set_show_avg_summary_amount(0)
        set_show_device_wallet(1)
        set_show_exempted_vehicles(1)
        set_show_fastag_payment(0)
        set_show_inventory(1)
        set_show_monthly_pass(1)
        set_show_monthly_pass_log(1)
        set_show_monthlypass_request(1)
        set_show_operator(1)
        set_show_paid_unpaid_amount(0)
        set_show_parking_slot_bookings(1)
        set_show_permit_apartments(1)
        set_show_rfid_column(1)
        set_show_rfid_recharge(1)
        set_show_time_till_seconds(0)
        set_show_vaccine_drive(0)
        set_show_validity_column(1)
        set_view_only(0)
        set_rfid_validity_default(0)
        set_show_resources_separately(0)
        set_show_profile(0)
        set_show_visitor_logs(1)

        set_hide_mobile_number(0)
        set_show_reserved_column(1)
        set_show_exit_vehicle_button(1)
        set_show_ieems_section(1)
        set_show_rfid_logs(1)
        set_show_company_column(1)
        set_show_permits(1)
        set_show_clients_info(1)
        set_show_dashboard_users(1)
        set_show_card_inventory(1)
        set_show_rfid_deleted_details(1)
        set_show_site_audits(1)
        set_show_warrior_users(1)
        set_show_map_view(1)
        set_show_parking_details(1)
        set_show_onboard_users(1)
        set_show_parking_terminals(1)
        set_show_dashboard_summary(0)

    }

    const superAdminFlags = () => {
        set_allow_create_parking(1)
        set_allow_download_parkings(1)
        set_allow_update_parking(1)
        set_allow_parking_led_settings(1)
        set_allow_parking_info_edit(1)
        set_allow_parking_license_update(1)
        set_allow_parking_status_toggle(1)
        set_allow_terminal_edit(1)
        set_show_verify_vehicle(1)
        set_show_dashboard_logs(1)
        set_show_fastag_api_data(1)
        set_show_device_issues(1)
        set_show_parking_analytics(1)
        set_create_without_terminal(1)
        set_allow_terminal_device_changes(1)
        set_show_rfid_payments(1)
        set_show_floor_occupancy(1)
        set_show_currently_parked(1)
        set_show_settlements(1)
        set_show_qr_transactions(1)
    }

    const adminFlags = () => {
        set_allow_create_parking(0)
        set_allow_download_parkings(0)
        set_allow_update_parking(0)
        set_allow_parking_led_settings(0)
        set_allow_parking_info_edit(0)
        set_allow_parking_license_update(0)
        set_allow_parking_status_toggle(0)
        set_allow_terminal_edit(0)
        set_show_verify_vehicle(0)
        set_show_dashboard_logs(0)
        set_show_fastag_api_data(0)
        set_show_device_issues(0)
        set_show_parking_analytics(0)
    }

    const pmsSupportFlags = () => {
        set_allow_fastag(0)
        set_allow_rfid_create(0)
        set_allow_rfid_delete(0)
        set_hide_parking_section(0)
        set_hide_vehicle_database(0)
        set_show_flat_details(0)
        set_show_rfid_requests(0)
        set_show_tag_column(0)
        set_show_rfid_company(0)
        set_show_rfid_inventory(0)
        set_show_rfid(0)
        set_show_parking_controllers(0)
        set_allow_unallocated_rfid(0)
        set_all_parkings_details(1)
        set_allow_company_user_create(0)
        set_allow_current_vehicles_update(0)
        set_allow_edit_monthly_pass(0)
        set_allow_pass_delete(0)
        set_allow_pass_recharge(0)
        set_company_user(0)
        set_create_permit_name_required(0)
        set_hide_device_issues(0)
        set_hide_operator_users(0)
        set_hide_parking_details(0)
        set_hide_parking_led(0)
        set_show_avg_summary_amount(0)
        set_show_device_wallet(1)
        set_show_exempted_vehicles(1)
        set_show_fastag_payment(0)
        set_show_inventory(0)
        set_show_monthly_pass(1)
        set_show_monthly_pass_log(1)
        set_show_monthlypass_request(1)
        set_show_operator(1)
        set_show_paid_unpaid_amount(0)
        set_show_parking_slot_bookings(1)
        set_show_permit_apartments(0)
        set_show_rfid_column(0)
        set_show_rfid_recharge(0)
        set_show_time_till_seconds(0)
        set_show_vaccine_drive(0)
        set_show_validity_column(0)
        set_view_only(0)
        set_rfid_validity_default(0)
        set_show_resources_separately(0)
        set_show_profile(0)
        set_show_visitor_logs(1)

        set_show_reserved_column(0)
        set_show_exit_vehicle_button(0)
        set_show_ieems_section(0)
        set_show_rfid_logs(0)
        set_show_company_column(0)
        set_show_permits(0)
        set_show_parking_terminals(1)
    }

    const commonSupportFlags = () => {
        set_hide_mobile_number(0)
        set_show_clients_info(0)
        set_show_dashboard_users(1)
        set_show_card_inventory(0)
        set_show_rfid_deleted_details(0)
        set_show_site_audits(0)
        set_show_warrior_users(0)
        set_show_device_issues(0)
        set_show_map_view(0)
        set_show_parking_details(0)
        set_show_dashboard_logs(0)
        set_show_fastag_api_data(0)
        set_show_onboard_users(0)
        set_allow_terminal_edit(0)
        set_show_parking_analytics(0)
        set_show_dashboard_summary(0)
        set_show_verify_vehicle(0)
        set_create_without_terminal(0)
        set_allow_terminal_device_changes(0)
    }

    const imsSupportFlags = () => {
        set_show_reserved_column(1)
        set_show_exit_vehicle_button(1)
        set_show_ieems_section(1)
        set_show_rfid_logs(1)
        set_show_company_column(1)
        set_show_permits(1)

        set_allow_fastag(1)
        set_allow_rfid_create(0)
        set_allow_rfid_delete(0)
        set_hide_parking_section(1)
        set_hide_vehicle_database(1)
        set_show_flat_details(1)
        set_show_rfid_requests(1)
        set_show_tag_column(1)
        set_show_rfid_company(1)
        set_show_rfid_inventory(1)
        set_show_rfid(1)
        set_show_parking_controllers(1)
        set_allow_unallocated_rfid(0)
        set_all_parkings_details(0)
        set_allow_company_user_create(0)
        set_allow_current_vehicles_update(0)
        set_allow_edit_monthly_pass(0)
        set_allow_pass_delete(0)
        set_allow_pass_recharge(0)
        set_company_user(0)
        set_create_permit_name_required(0)
        set_hide_device_issues(0)
        set_hide_operator_users(1)
        set_hide_parking_details(0)
        set_hide_parking_led(1)
        set_show_avg_summary_amount(0)
        set_show_device_wallet(0)
        set_show_exempted_vehicles(0)
        set_show_fastag_payment(0)
        set_show_inventory(1)
        set_show_monthly_pass(0)
        set_show_monthly_pass_log(0)
        set_show_monthlypass_request(0)
        set_show_operator(1)
        set_show_paid_unpaid_amount(0)
        set_show_parking_slot_bookings(0)
        set_show_permit_apartments(1)
        set_show_rfid_column(1)
        set_show_rfid_recharge(1)
        set_show_time_till_seconds(0)
        set_show_vaccine_drive(0)
        set_show_validity_column(1)
        set_view_only(0)
        set_rfid_validity_default(0)
        set_show_resources_separately(0)
        set_show_profile(0)
        set_show_visitor_logs(1)
        set_show_parking_terminals(1)
    }

    const corporateFlags = () => {
        set_allow_company_user_create(1)
        set_allow_fastag(1)
        set_allow_rfid_create(1)
        set_allow_rfid_delete(1)
        set_show_rfid(1)
        set_show_rfid_company(1)
        set_show_rfid_requests(1)
        set_show_tag_column(1)
        set_rfid_validity_default(1)
        set_hide_mobile_number(1)
        set_show_reserved_column(1)
        set_show_exit_vehicle_button(1)
        set_allow_current_vehicles_update(1)
        set_show_dashboard_summary(1)
        set_show_rfid_inventory(1)
        set_show_parking_controllers(1)
        set_hide_parking_section(1)
        set_hide_vehicle_database(1)
    }

    const speicalCaseFlags = () => {
        set_make_exit_free(0)
        set_show_rfid_payments(0)
        set_show_anpr_raw_image(0)
        set_disable_downloads(0)
    }

    const salesFlags = () => {
        set_show_anpr_options(1)
        set_show_rfid_payments(1)
        set_vehicle_mobile_mask(1)
        set_show_reports(1)
        set_use_latest_version(1)
        set_show_ieems_section(1)
        set_show_visitor_logs(1)
        set_view_only(1)
        set_hide_vehicle_database(1)
        set_hide_operator_users(1)
        set_hide_parking_details(1)
        set_hide_device_issues(1)
        set_hide_parking_led(1)
        set_show_parking_controllers(1)
        set_show_rfid_inventory(1)
        set_show_time_till_seconds(1)
        set_show_monthly_pass_log(1)
        set_hide_mobile_number(1)
        set_show_tag_column(1)
        set_show_validity_column(1)
        set_show_rfid_requests(1)
        set_show_rfid_company(1)
        set_show_rfid_column(1)
        set_show_rfid(1)
        set_show_permit_apartments(1)
        set_show_flat_details(1)
        set_show_fastag_payment(1)
        set_allow_fastag(1)
    }

    React.useEffect(() => {
        speicalCaseFlags()
        if (parking_type === "default") {
            defaultFlags()
            commonFlags()
        } else if (parking_type === 'corporate') {
            commonFlags()
            corporateFlags()
        } else if (parking_type === "society") {
            societyTemplateDefaultFlags()
            commonFlags()
        } else if (parking_type === "superAdmin") {
            commonAdminFlags()
            superAdminFlags()
        } else if (parking_type === 'admin') {
            commonAdminFlags()
            adminFlags()
        } else if (parking_type === 'pmsSupport') {
            commonSupportFlags()
            pmsSupportFlags()
        } else if (parking_type === 'imsSupport') {
            commonSupportFlags()
            imsSupportFlags()
        } else if (parking_type === 'sales') {
            salesFlags()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parking_type])

    return <>
        {
            show_edit_configuration ?
                <div style={{ marginBottom: 40 }}>
                    <Typography style={{ marginBottom: 15, fontWeight: "bold" }}>User Configuration:</Typography>
                    <>
                        <div style={{ marginTop: 20 }}>
                            <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>Permit:</Typography>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                                <FormControlLabel control={<Checkbox
                                    checked={allow_unallocated_rfid === 1 ? true : false}
                                    onChange={(event) => set_allow_unallocated_rfid(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Unallocated RFID" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_company_user_create === 1 ? true : false}
                                    onChange={(event) => set_allow_company_user_create(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Company user Create" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_fastag === 1 ? true : false}
                                    onChange={(event) => set_allow_fastag(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Fastag" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_rfid_create === 1 ? true : false}
                                    onChange={(event) => set_allow_rfid_create(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow RFID Create" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_rfid_delete === 1 ? true : false}
                                    onChange={(event) => set_allow_rfid_delete(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow RFID Delete" />
                                <FormControlLabel control={<Checkbox
                                    checked={company_user === 1 ? true : false}
                                    onChange={(event) => set_company_user(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Company User" />
                                <FormControlLabel control={<Checkbox
                                    checked={create_permit_name_required === 1 ? true : false}
                                    onChange={(event) => set_create_permit_name_required(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Create Permit Name Required" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_fastag_payment === 1 ? true : false}
                                    onChange={(event) => set_show_fastag_payment(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Fastag Payment" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_flat_details === 1 ? true : false}
                                    onChange={(event) => set_show_flat_details(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Flat Details" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_permit_apartments === 1 ? true : false}
                                    onChange={(event) => set_show_permit_apartments(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Permit Apartments" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid === 1 ? true : false}
                                    onChange={(event) => set_show_rfid(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_column === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_column(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID Column" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_recharge === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_recharge(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID Recharge" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_company === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_company(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID Company" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_requests === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_requests(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID Requests" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_tag_column === 1 ? true : false}
                                    onChange={(event) => set_show_tag_column(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Tag Column" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_validity_column === 1 ? true : false}
                                    onChange={(event) => set_show_validity_column(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="RFID Validity Column" />
                                <FormControlLabel control={<Checkbox
                                    checked={rfid_validity_default === 1 ? true : false}
                                    onChange={(event) => set_rfid_validity_default(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="RFID Validity Default" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_resources_separately === 1 ? true : false}
                                    onChange={(event) => set_show_resources_separately(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Resources Separately" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_profile === 1 ? true : false}
                                    onChange={(event) => set_show_profile(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Profile" />

                                <FormControlLabel control={<Checkbox
                                    checked={hide_mobile_number === 1 ? true : false}
                                    onChange={(event) => set_hide_mobile_number(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Hide Mobile Number" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_reserved_column === 1 ? true : false}
                                    onChange={(event) => set_show_reserved_column(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Reserved Column" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_exit_vehicle_button === 1 ? true : false}
                                    onChange={(event) => set_show_exit_vehicle_button(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Exit Vehicle Button" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_permits === 1 ? true : false}
                                    onChange={(event) => set_show_permits(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Permits" />
                            </div>
                        </div>


                        <div style={{ marginTop: 20 }}>
                            <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>Monthly Pass:</Typography>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                                <FormControlLabel control={<Checkbox
                                    checked={allow_edit_monthly_pass === 1 ? true : false}
                                    onChange={(event) => set_allow_edit_monthly_pass(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Edit Monthly Pass" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_pass_delete === 1 ? true : false}
                                    onChange={(event) => set_allow_pass_delete(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Pass Delete" />

                                <FormControlLabel control={<Checkbox
                                    checked={allow_pass_recharge === 1 ? true : false}
                                    onChange={(event) => set_allow_pass_recharge(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Pass Recharge" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_monthly_pass === 1 ? true : false}
                                    onChange={(event) => set_show_monthly_pass(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Monthly Pass" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_monthly_pass_log === 1 ? true : false}
                                    onChange={(event) => set_show_monthly_pass_log(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Monthly Pass Log" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_monthlypass_request === 1 ? true : false}
                                    onChange={(event) => set_show_monthlypass_request(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Monthly Pass Request" />
                            </div>
                        </div>


                        <div style={{ marginTop: 20 }}>
                            <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>Parking:</Typography>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                                <FormControlLabel control={<Checkbox
                                    checked={allow_current_vehicles_update === 1 ? true : false}
                                    onChange={(event) => set_allow_current_vehicles_update(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Current Vehicle Update" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_avg_summary_amount === 1 ? true : false}
                                    onChange={(event) => set_show_avg_summary_amount(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Avg. Summary Amount" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_paid_unpaid_amount === 1 ? true : false}
                                    onChange={(event) => set_show_paid_unpaid_amount(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Paid Unpaid Amount" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_time_till_seconds === 1 ? true : false}
                                    onChange={(event) => set_show_time_till_seconds(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Time Till Seconds" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_parking_analytics === 1 ? true : false}
                                    onChange={(event) => set_show_parking_analytics(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Parking Analytics" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_dashboard_summary === 1 ? true : false}
                                    onChange={(event) => set_show_dashboard_summary(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Dashboard Summary" />

                            </div>
                        </div>

                        <div style={{ marginTop: 20 }}>
                            <Typography style={{ marginBottom: 10, fontWeight: "bold" }}>General:</Typography>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>
                                <FormControlLabel control={<Checkbox
                                    checked={all_parkings_details === 1 ? true : false}
                                    onChange={(event) => set_all_parkings_details(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="All Parkings Logs" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_inventory === 1 ? true : false}
                                    onChange={(event) => set_show_inventory(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Inventory" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_inventory === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_inventory(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID Inventory" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_parking_slot_bookings === 1 ? true : false}
                                    onChange={(event) => set_show_parking_slot_bookings(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Parking Slot Booking" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_operator === 1 ? true : false}
                                    onChange={(event) => set_show_operator(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Operator" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_verify_vehicle === 1 ? true : false}
                                    onChange={(event) => set_show_verify_vehicle(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Verify Vehicle" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_parking_controllers === 1 ? true : false}
                                    onChange={(event) => set_show_parking_controllers(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Parking Controllers" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_device_wallet === 1 ? true : false}
                                    onChange={(event) => set_show_device_wallet(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Device Wallet" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_exempted_vehicles === 1 ? true : false}
                                    onChange={(event) => set_show_exempted_vehicles(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Exempted Vehicles" />
                                <FormControlLabel control={<Checkbox
                                    checked={hide_parking_led === 1 ? true : false}
                                    onChange={(event) => set_hide_parking_led(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Hide Parking Led" />

                                <FormControlLabel control={<Checkbox
                                    checked={hide_parking_section === 1 ? true : false}
                                    onChange={(event) => set_hide_parking_section(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Hide Parking Section" />
                                <FormControlLabel control={<Checkbox
                                    checked={hide_device_issues === 1 ? true : false}
                                    onChange={(event) => set_hide_device_issues(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Hide Device Issues" />

                                <FormControlLabel control={<Checkbox
                                    checked={hide_operator_users === 1 ? true : false}
                                    onChange={(event) => set_hide_operator_users(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Hide Operator Users" />

                                <FormControlLabel control={<Checkbox
                                    checked={hide_parking_details === 1 ? true : false}
                                    onChange={(event) => set_hide_parking_details(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Hide Parking Details" />
                                <FormControlLabel control={<Checkbox
                                    checked={hide_vehicle_database === 1 ? true : false}
                                    onChange={(event) => set_hide_vehicle_database(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Hide Vehicle Database" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_vaccine_drive === 1 ? true : false}
                                    onChange={(event) => set_show_vaccine_drive(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Vaccine Drive" />
                                <FormControlLabel control={<Checkbox
                                    checked={view_only === 1 ? true : false}
                                    onChange={(event) => set_view_only(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="View Only" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_visitor_logs === 1 ? true : false}
                                    onChange={(event) => set_show_visitor_logs(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Visitor Logs" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_ieems_section === 1 ? true : false}
                                    onChange={(event) => set_show_ieems_section(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show IEEMS Section" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_logs === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_logs(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID Logs" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_company_column === 1 ? true : false}
                                    onChange={(event) => set_show_company_column(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Company Column" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_clients_info === 1 ? true : false}
                                    onChange={(event) => set_show_clients_info(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Client Info" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_dashboard_users === 1 ? true : false}
                                    onChange={(event) => set_show_dashboard_users(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Dashboard Users" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_card_inventory === 1 ? true : false}
                                    onChange={(event) => set_show_card_inventory(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Card Inventory" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_deleted_details === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_deleted_details(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show RFID Deleted Details" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_site_audits === 1 ? true : false}
                                    onChange={(event) => set_show_site_audits(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Site Audits" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_warrior_users === 1 ? true : false}
                                    onChange={(event) => set_show_warrior_users(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Warrior Users" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_device_issues === 1 ? true : false}
                                    onChange={(event) => set_show_device_issues(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Device Issues" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_map_view === 1 ? true : false}
                                    onChange={(event) => set_show_map_view(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Map View" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_parking_details === 1 ? true : false}
                                    onChange={(event) => set_show_parking_details(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Parking Detials" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_dashboard_logs === 1 ? true : false}
                                    onChange={(event) => set_show_dashboard_logs(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Dashboard Logs" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_fastag_api_data === 1 ? true : false}
                                    onChange={(event) => set_show_fastag_api_data(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Fastag API Data" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_onboard_users === 1 ? true : false}
                                    onChange={(event) => set_show_onboard_users(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Onboard Users" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_parking_terminals === 1 ? true : false}
                                    onChange={(event) => set_show_parking_terminals(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Parking Terminals" />
                                <FormControlLabel control={<Checkbox checked={allow_create_parking === 1 ? true : false} onChange={(event) => set_allow_create_parking(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                                    label="Allow Parking Create" />
                                <FormControlLabel control={<Checkbox checked={allow_download_parkings === 1 ? true : false} onChange={(event) => set_allow_download_parkings(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                                    label="Allow Parking Download" />
                                <FormControlLabel control={<Checkbox checked={allow_update_parking === 1 ? true : false} onChange={(event) => set_allow_update_parking(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                                    label="Allow Parking Settings" />
                                <FormControlLabel control={<Checkbox checked={allow_parking_led_settings === 1 ? true : false} onChange={(event) => set_allow_parking_led_settings(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                                    label="Allow Parking LED Settings" />
                                <FormControlLabel control={<Checkbox checked={allow_parking_info_edit === 1 ? true : false} onChange={(event) => set_allow_parking_info_edit(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                                    label="Allow Parking Info Edit" />
                                <FormControlLabel control={<Checkbox checked={allow_parking_license_update === 1 ? true : false} onChange={(event) => set_allow_parking_license_update(event.target.checked === true ? 1 : 0)} inputProps={{ 'aria-label': 'controlled' }} />}
                                    label="Allow Parking License Update" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_parking_status_toggle === 1 ? true : false}
                                    onChange={(event) => set_allow_parking_status_toggle(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Parking Status Toggle" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_terminal_edit === 1 ? true : false}
                                    onChange={(event) => set_allow_terminal_edit(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Terminal Edit" />
                                <FormControlLabel control={<Checkbox
                                    checked={create_without_terminal === 1 ? true : false}
                                    onChange={(event) => set_create_without_terminal(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Create Without Terminal" />
                                <FormControlLabel control={<Checkbox
                                    checked={allow_terminal_device_changes === 1 ? true : false}
                                    onChange={(event) => set_allow_terminal_device_changes(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Allow Terminal & Operator Device Changes" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_purchased_fastag === 1 ? true : false}
                                    onChange={(event) => set_show_purchased_fastag(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Purchased Fastag" />
                                <FormControlLabel control={<Checkbox
                                    checked={create_permit_without_mobile === 1 ? true : false}
                                    onChange={(event) => set_create_permit_without_mobile(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Create Permit Without Mobile" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_cameras === 1 ? true : false}
                                    onChange={(event) => set_show_cameras(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Cameras" />
                                <FormControlLabel control={<Checkbox
                                    checked={separate_summary_of_devices === 1 ? true : false}
                                    onChange={(event) => set_separate_summary_of_devices(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Separate Summary of Devices" />
                                <FormControlLabel control={<Checkbox
                                    checked={use_24_hour_format === 1 ? true : false}
                                    onChange={(event) => set_use_24_hour_format(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Use 24hr Format" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_surveillance_images === 1 ? true : false}
                                    onChange={(event) => set_show_surveillance_images(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Surveillance Images" />
                                <FormControlLabel control={<Checkbox
                                    checked={use_latest_version === 1 ? true : false}
                                    onChange={(event) => set_use_latest_version(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Use Latest Version" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_anpr_raw_image === 1 ? true : false}
                                    onChange={(event) => set_show_anpr_raw_image(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show ANPR Raw Images" />
                                <FormControlLabel control={<Checkbox
                                    checked={make_exit_free === 1 ? true : false}
                                    onChange={(event) => set_make_exit_free(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Make Exit Free" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_reports === 1 ? true : false}
                                    onChange={(event) => set_show_reports(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Reports" />


                                <FormControlLabel control={<Checkbox
                                    checked={show_patrolling === 1 ? true : false}
                                    onChange={(event) => set_show_patrolling(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Patrolling" />


                                <FormControlLabel control={<Checkbox
                                    checked={separate_entry_exit_images === 1 ? true : false}
                                    onChange={(event) => set_separate_entry_exit_images(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Separate Entry Exit Images" />


                                <FormControlLabel control={<Checkbox
                                    checked={vehicle_mobile_mask === 1 ? true : false}
                                    onChange={(event) => set_vehicle_mobile_mask(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Vehicle & Mobile Mask" />

                                <FormControlLabel control={<Checkbox
                                    checked={check_vehicle_exit === 1 ? true : false}
                                    onChange={(event) => set_check_vehicle_exit(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Check Vehicle Exit" />
                                <FormControlLabel control={<Checkbox
                                    checked={demo_access === 1 ? true : false}
                                    onChange={(event) => set_demo_access(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Demo Access" />
                                <FormControlLabel control={<Checkbox
                                    checked={create_sub_user === 1 ? true : false}
                                    onChange={(event) => set_create_sub_user(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Create Sub User" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_qr_transactions === 1 ? true : false}
                                    onChange={(event) => set_show_qr_transactions(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show QR Transactions" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_rfid_payments === 1 ? true : false}
                                    onChange={(event) => set_show_rfid_payments(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Permit Payments" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_anpr_options === 1 ? true : false}
                                    onChange={(event) => set_show_anpr_options(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show ANPR Options" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_ramp_entry === 1 ? true : false}
                                    onChange={(event) => set_show_ramp_entry(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Ramp Entry" />

                                <FormControlLabel control={<Checkbox
                                    checked={show_floor_occupancy === 1 ? true : false}
                                    onChange={(event) => set_show_floor_occupancy(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Floot Occupancy" />

                                <FormControlLabel control={<Checkbox
                                    checked={vehicle_summary_mask === 1 ? true : false}
                                    onChange={(event) => set_vehicle_summary_mask(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Vehicle Summary Mask" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_dashboard_categories === 1 ? true : false}
                                    onChange={(event) => set_show_dashboard_categories(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Dashboard Categories" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_currently_parked === 1 ? true : false}
                                    onChange={(event) => set_show_currently_parked(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Currently Parked" />
                                <FormControlLabel control={<Checkbox
                                    checked={show_settlements === 1 ? true : false}
                                    onChange={(event) => set_show_settlements(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Show Settlements" />

                                <FormControlLabel control={<Checkbox
                                    checked={edit_device_limit === 1 ? true : false}
                                    onChange={(event) => set_edit_device_limit(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Edit Device Limit" />

                                <FormControlLabel control={<Checkbox
                                    checked={slot_name_required === 1 ? true : false}
                                    onChange={(event) => set_slot_name_required(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Slot Name Required" />

                                <FormControlLabel control={<Checkbox
                                    checked={restrict_permits === 1 ? true : false}
                                    onChange={(event) => set_restrict_permits(event.target.checked === true ? 1 : 0)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Restrict Permits" />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={disable_downloads === 1}
                                            onChange={(event) => set_disable_downloads(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Disable Downloads"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={allow_visitor_delete === 1}
                                            onChange={(event) => set_allow_visitor_delete(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Allow Visitor Delete"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={allow_client_view === 1}
                                            onChange={(event) => set_allow_client_view(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Allow Client View"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_summary_search === 1}
                                            onChange={(event) => set_hide_summary_search(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Summary Search"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_barrier_activity === 1}
                                            onChange={(event) => set_show_barrier_activity(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Barrier Activity"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_pucc_validity === 1}
                                            onChange={(event) => set_show_pucc_validity(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show PUCC Validity"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_dashboard_insights === 1}
                                            onChange={(event) => set_show_dashboard_insights(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Dashboard Insights"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_date_wise_filter === 1}
                                            onChange={(event) => set_hide_date_wise_filter(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Date Wise Filter"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_monthly_wise_date_filter === 1}
                                            onChange={(event) => set_hide_monthly_wise_date_filter(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Monthly Wise Filter"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_custom_date_filter === 1}
                                            onChange={(event) => set_hide_custom_date_filter(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Custom Date Filter"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_time_filter === 1}
                                            onChange={(event) => set_hide_time_filter(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Time Filter"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={date_till_yesterday === 1}
                                            onChange={(event) => set_date_till_yesterday(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Date Till Yesterday"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_qr_codes === 1}
                                            onChange={(event) => set_show_qr_codes(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show QR Codes"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_valet_bookings === 1}
                                            onChange={(event) => set_show_valet_bookings(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Valet Bookings"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_missed_visitors === 1}
                                            onChange={(event) => set_show_missed_visitors(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Missed Visitors"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_apartment_as_unit === 1}
                                            onChange={(event) => set_show_apartment_as_unit(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Apartment as Unit"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={only_allow_day_permit === 1}
                                            onChange={(event) => set_only_allow_day_permit(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Only Allow Day Permit"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_resources === 1}
                                            onChange={(event) => set_hide_resources(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Resources"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_contact_us === 1}
                                            onChange={(event) => set_hide_contact_us(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Contact Us"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_linked_permit_logs === 1}
                                            onChange={(event) => set_show_linked_permit_logs(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Linked Permit Logs"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_permit_validity_toggle === 1}
                                            onChange={(event) => set_show_permit_validity_toggle(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Permit Validity Toggle"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_permit_amount_details === 1}
                                            onChange={(event) => set_hide_permit_amount_details(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Permit Amount Details"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_billing_invocies === 1}
                                            onChange={(event) => set_show_billing_invocies(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Billing Invoices"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_invoices_user_permits === 1}
                                            onChange={(event) => set_show_invoices_user_permits(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Invoices User Permits"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_invoices_vaahan_api === 1}
                                            onChange={(event) => set_show_invoices_vaahan_api(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Invoices Vaahan API"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={allow_add_inventory_tags === 1}
                                            onChange={(event) => set_allow_add_inventory_tags(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Allow Add Inventory Tags"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_permit_user_bulk_action === 1}
                                            onChange={(event) => set_hide_permit_user_bulk_action(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Permit User Bulk Action"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_change_password === 1}
                                            onChange={(event) => set_hide_change_password(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Change Password"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_permit_users_filter === 1}
                                            onChange={(event) => set_hide_permit_users_filter(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Permit Users Filter"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={only_show_vehicle_search === 1}
                                            onChange={(event) => set_only_show_vehicle_search(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Only Show Vehicle Search"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hide_unnecessary_permit_users_column === 1}
                                            onChange={(event) => set_hide_unnecessary_permit_users_column(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Hide Unnecessary Permit Users Column"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_tutorial === 1}
                                            onChange={(event) => set_show_tutorial(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Tutorial"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_vehicle_not_registered_msg === 1}
                                            onChange={(event) => set_show_vehicle_not_registered_msg(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Vehicle Not Registered Message"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_searched_data_only === 1}
                                            onChange={(event) => set_show_searched_data_only(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Searched Data Only"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_permit_defaulter === 1}
                                            onChange={(event) => set_show_permit_defaulter(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Permit Defaulter"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_grace_period === 1}
                                            onChange={(event) => set_show_grace_period(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Grace Period"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_grace_period_logs === 1}
                                            onChange={(event) => set_show_grace_period_logs(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Grace Period Logs"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_grace_period_configurations === 1}
                                            onChange={(event) => set_show_grace_period_configurations(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Grace Period Configurations"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_billings_maintenance_plan === 1}
                                            onChange={(event) => set_show_billings_maintenance_plan(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Billings Maintenance Plan"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_floor_occupancy_edit === 1}
                                            onChange={(event) => set_show_floor_occupancy_edit(event.target.checked ? 1 : 0)}
                                        />
                                    }
                                    label="Show Floor Occupancy Edit"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_operator_devices === 1 ? true : false}
                                            onChange={(event) =>
                                                set_show_operator_devices(event.target.checked === true ? 1 : 0)
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    }
                                    label="Show Operator Devices"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_operator_shifts === 1 ? true : false}
                                            onChange={(event) =>
                                                set_show_operator_shifts(event.target.checked === true ? 1 : 0)
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    }
                                    label="Show Operator Shifts"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_operator_users === 1 ? true : false}
                                            onChange={(event) =>
                                                set_show_operator_users(event.target.checked === true ? 1 : 0)
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    }
                                    label="Show Operator Users"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={auto_refresh_vehicle_summary === 1 ? true : false}
                                            onChange={(event) =>
                                                set_auto_refresh_vehicle_summary(event.target.checked === true ? 1 : 0)
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    }
                                    label="Auto Refresh Vehicle Summary"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={show_start_end_date_pairing_input === 1 ? true : false}
                                            onChange={(event) =>
                                                set_show_start_end_date_pairing_input(event.target.checked === true ? 1 : 0)
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    }
                                    label="Show Start End Date Pairing"
                                />
                            </div>
                        </div>

                    </>
                </div> : <div><Button startIcon={<EditIcon />} onClick={() => set_show_edit_configuration(true)} style={{ width: 250, marginBottom: 40 }}>Edit Configuration</Button></div>
        }
    </>

}

export const CrmUserCreate = ({ permissions, ...props }) => {
    const eventTracker = UseAnalyticsEvent()
    const [allowAdminCreation] = useState(sessionStorage.getItem("allow_admin_creation") === "1");
    let parkingTypes = allowAdminCreation ?
        [
            { id: 'default', name: 'Default' },
            { id: 'corporate', name: 'Corporate' },
            { id: 'society', name: 'Society' },
            { id: 'superAdmin', name: 'Super Admin' },
            { id: 'admin', name: 'Admin' },
            { id: 'pmsSupport', name: 'PMS Support' },
            { id: 'imsSupport', name: 'IMS Support' },
            { id: 'sales', name: 'Sales' },
        ]
        :
        [
            { id: 'default', name: 'Default' },
            { id: 'society', name: 'Society' },
        ]
    const [parkingType, setParkingType] = useState("")

    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    React.useEffect(() => {
        eventTracker(CATEGORY, "CREATE DASHBOARD USER")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Create {...props} onFailure={onFailure} onSuccess={onSuccess} title="Create CRM User">
            <SimpleForm {...props} validate={validateUserCreation} toolbar={<CreateCustomToolbar />} redirect="list">

                <div className="formLabel-bold" style={{ marginTop: 5 }}>User Details</div>

                <div className="grid-250" style={{ marginTop: 8 }}>
                    <TextInput source="username" variant="outlined" />
                    <TextInput source="full_name" variant="outlined" />
                    <TextInput source="display_name" variant="outlined" />
                    <TextInput source="password" type="password" variant="outlined" />
                    <TextInput source="confirm_password" type="password" label="Confirm Password" variant="outlined" />
                    <br />
                    <TextInput source="email" variant="outlined" />
                    <TextInput source="mobile" variant="outlined" />
                </div>

                <div className="grid-250" style={{ marginTop: 8 }}>
                    <FormDataConsumer>{CustomParkingSelector}</FormDataConsumer>
                    <SelectInput variant="outlined" label="User Template" source="parking_type" choices={parkingTypes} defaultValue={parkingTypes[0].id} value={parkingType} onChange={event => setParkingType(event.target.value)} />
                </div>

                {permissions === 'admin' && allowAdminCreation ? <RadioButtonGroupInput source="role" choices={choices} optionText="name" optionValue="id" /> : <RadioButtonGroupInput source="role" choices={choicesContractor} optionText="name" optionValue="id" />}
                <CustomCreateForm />
            </SimpleForm>
        </Create>
    )
};

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 11,
        height: 11,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        height: "auto",
        paddingTop: 2,
        paddingBottom: 2
    },
    checked: {},
}))(Switch);
